import './vn.css';
import React, { useState, useEffect, useRef } from 'react';
import overlay from'../../images/overlay.gif'
import loadingAnim from'../../images/loading.gif'
import achievements from'../../services/achievements';
import parse from 'html-react-parser'
import { audio, ambient, musicContinue, musicContinueSwitch, playMusic, pauseMusic, setVolume, transitionVolume, transitionSpeed, stopMusic, isPlaying, playEffects, setVolumeEffects, stopEffects, transitionVolumeEffects, isPlayingEffects, playAmbient, setVolumeAmbient, transitionVolumeAmbient, transitionSpeedAmbient, stopAmbient, playEffectsVN, stopEffectsVN, setVolumeEffectsVN, transitionVolumeEffectsVN, isPlayingEffectsVN, changeMusicSpeed, changeAmbientSpeed} from '../musicEngine/musicEngine';
import whoosh from'../../m/whoosh.js'
import achievementSound from'../../m/achievement.js'
import timer from'../../m/timer.js'
import holding from'../../m/holding.js'
import complete from'../../m/complete.js'
import licking from'../../m/licking.js'
import failed from'../../m/failed.js'
import hollow1 from'../../m/phoebe/hollow1.js'
import hollow2 from'../../m/phoebe/hollow2.js'
import chapterCompleted from'../../m/chapterCompleted.js'

function Vn({goMenu, plot, background, step, goNext, isLS, startCoordinates, state, achievementsSave, phoebesComfort, achievementCondition, gallerySC, language, hzAdjuster}) {
  const [save, setSave] = useState(0);
  const [savePhoebesComfort, setSavePhoebesComfort] = useState(0);
  const [saveAchievementCondition, setSaveAchievementCondition] = useState(0);
  const [saveAchievements, setSaveAchievements] = useState(0);
  const [saveGallerySC, setSaveGallerySC] = useState(0);
  //
  const bgRef = useRef(null);
  const bgRefUnder = useRef(null);
  const bgTappingRef = useRef(null);
  const sceneRef = useRef(null);
  const sceneRefBG = useRef(null);
  const sceneRefUnder = useRef(null);
  const sceneRefVid = useRef(null);
  const sceneRefVidUnder = useRef(null);
  const charRefLeft = useRef(null);
  const charRefLeftUnder = useRef(null);
  const charRefRight = useRef(null);
  const charRefRightUnder = useRef(null);
  const textBoxLeft = useRef(null);
  const textBoxRight = useRef(null);
  const answersBox = useRef(null);
  const answerBox0 = useRef(null);
  const answerBox1 = useRef(null);
  const answerBox2 = useRef(null);
  const answerBox3 = useRef(null);
  const timerText = useRef(null);
  const wrap = useRef(null);
  const arrowBack = useRef(null);
  const loadingPic = useRef(null);
  const achievement = useRef(null);
  const item = useRef(null);
  const sliderButtonRefCircleRef = useRef(null);
  const sliderButtonRef = useRef(null);
  const tapButtonRef = useRef(null);
  const holdButtonRef = useRef(null);
  const actionButtons = useRef(null);
  const timerAction = useRef(null);
  const blackScreenRef = useRef(null);
  const vidBottom = useRef(null);
  const vidTop = useRef(null);
  const vidButton = useRef(null);
  const vidPause = useRef(null);
  const vid = useRef(null);
  const vidProgress = useRef(null);
  const vidTime = useRef(null);
  const bgRefVid = useRef(null);
  const bgRefVidUnder = useRef(null);
  const fade = useRef(null);
  const textBoxLeftInner = useRef(null);
  const textBoxRightInner = useRef(null);
  //
  let currentBg = useRef(undefined);
  let speedUp = useRef(false);
  let skipWaiting = useRef(false);
  let autoPlayDialog = useRef(false);
  let holdButtonComplete = useRef(false);
  let holdButtonActive = useRef(false);
  let sliderButtonComplete = useRef(false);
  let directionSlider = useRef("right"); //"up", "down", "left", "right"
  let currentPosition = useRef(0);
  let sliderDifficulty = useRef(0.05);
  let dragging = useRef(false);
  let targetPos = useRef(0);
  let pathLength = useRef(150);
  let startPos = useRef(undefined);
  let animationFrameId = useRef(undefined);
  let timerOn = useRef(false);
  let timerActionOn = useRef(false);
  let timerSet = useRef(false);
  let phoebeUncomfortableCondition = useRef(false);
  let speedUpIterations = useRef(false);
  let stopTexting = useRef(false);
  let texting = useRef(false);
  let charAppearing = useRef(false);
  let preCharAppearing = useRef(false);
  let loading = useRef(false);
  let endLoading = useRef(false);
  let skipButton = useRef(false);
  let prevPosition = useRef();
  let prevChar = useRef(false);
  let removeChar = useRef(false);
  let removeCharPosition = useRef(false);
  let answered = useRef(false);
  let prevAnswered = useRef([]);
  let answering = useRef(false);
  let arrowBackVisible = useRef(false);
  let particles = useRef(false);
  let exit = useRef(false);
  let animation = useRef(false);
  let warningShown = useRef(false);
  let itemFloating = useRef(false);
  let bgRefSave = useRef(false);
  let backMenuCheck = useRef(false);
  let nextStep = useRef(1);
  let answerNum = useRef(0);
  let numI = useRef(0);
  let numJ = useRef(0);
  let startMusic = useRef(false);
  let soundEffect = useRef(false);
  let startAmbient = useRef(false);
  let lastDrawTime = useRef(false);
  let rafScheduled = useRef(false);
  let pausedAfterLoad = useRef(false);
  let actionSound = useRef();
  let cachedImgs = useRef(new Map());
  let frameTasks = useRef(new Array());
  let savedAnswers = useRef(new Array());  //
  let hintUsedVar = useRef(isLS ? localStorage.getItem('hintUsedVarSC2') === null ? "hide" : JSON.parse(localStorage.getItem('hintUsedVarSC2')) : "hide");
  //
  const [charName, setCharName] = useState();
  const [textBoxLeftText, setTextBoxLeftText] = useState("");
  const [textBoxRightText, setTextBoxRightText] = useState("");
  const [isPlayingVid, setIsPlayingVid] = useState(true);
  //

  //action buttons listeners
  //tap button
  let sceneBGPositionZero, button1;
  let clicks = 0;
  const maxClicks = 20;
  let tapProgress=0;
  let tapping=true;
  let lastTap = 0;
  //hold button
  let holdButton, holdButtonReducerActive = false, startTime, interval, reduceInterval, holdProgress=0;
  //slider button
  let button;
  let spans;
//

let textTranslation = {
  en:{
    tap:"TAP",
    hold:"HOLD",
  },
  ru:{
    tap:"ЖМИ",
    hold:"ДЕРЖИ",
  }
}

const achievementsRu = [
  "Экстраверт",
  "Душнила",
  "Знаток кисок",
  "Доппельгангер",
  "Вообще мимо",
  "Впечатлить профессорку",
  "Помощник",
  "Настоящий друг",
  "Пальцем в небо",
  "Найти жемчужину",
  "Ценитель бюстов",
  "Поклонник поп-арта",
  "Sir Camelot",
  "Остаточные знания",
  "CUMанда МОКРЕНЬКИХ",
  "Влажный сон",
  "С водный спасатель",
  "Мечтатель",
  "Комфортик",
  "В работу с головой",
  "Специалист по домашке",
  "Скользкий язычок",
  "Статист",
  "Призрачный студент",
  "Лорд Бульборектал",
  "Анатом",
  "Барабанщик",
  "Раззява"
];

  useEffect(() => {
    document.addEventListener('deviceready', deviceReadyFunc, false);

    function deviceReadyFunc() {
      document.addEventListener('backbutton', onBackButton, false);
    }

    function onBackButton(e) {
      e.preventDefault();
      goToMenu();
    }
    //tap button
  button1 = document.querySelector(".pulseButton");

button1.addEventListener("click", tapListener);
        //hold button
            holdButton = document.querySelector(".holdButton");
            holdButton.addEventListener("mousedown", touchStart);
            holdButton.addEventListener("touchstart", touchStart);
            //
            holdButton.addEventListener("mouseup", touchEnd);
            holdButton.addEventListener("mouseleave", touchEnd);
            holdButton.addEventListener("touchend", touchEnd);
            holdButton.addEventListener("touchcancel", touchEnd);

            async function tapListener() {
                if (clicks < maxClicks) {
                    lastTap = Date.now();
                    let initialProgress = tapProgress;
                    clicks+=1.8;
                    tapProgress = clicks / maxClicks;
                    if(initialProgress <= 0 && tapProgress > 0){
                      setVolumeEffectsVN(0.5);
                      playEffectsVN(hollow1, false);
                    }
                    if(tapProgress<0){
                      tapProgress = 0;
                    }
                    button1.style.setProperty("--scale", tapProgress);
                    let animationShift = bgTappingRef.current.clientWidth/25;
                    let frame = Math.floor(tapProgress/(1/25));
                    if(frame>24){
                      frame=24;
                    }
                    let framePosition = sceneBGPositionZero+(animationShift*frame*-1);
                    bgTappingRef.current.style.transform = "translate("+framePosition+"px, 0)";
                    bgTappingRef.current.style.filter = "brightness("+(0.9+tapProgress*0.15)+")";
                    if(clicks >= maxClicks){
                        setVolumeEffectsVN(0.8);
                        playEffectsVN(hollow2, false);
                      try{
                        navigator.vibrate(100);
                    }catch(e){
                      console.log(e);
                    }
                      tapping=false;
                      button1.style.transition = "transform 0.6s ease";
                      button1.style.color = "#00cf14";
                      button1.style.background = "rgba(0, 135, 13, 0.7)";
                      button1.style.boxShadow = "0 0 0 0 rgba(0, 135, 13, .3)";
                      setTimeout(() => {
                      changeSetting(tapButtonRef,"current.style.opacity", 0, "", 0.02);
                    }, 400);
                    }
                }
            }

            function touchEnd(){
              if(holdButtonActive.current){
              if(holdButtonActive.current){
                transitionVolumeEffectsVN(0,200);
                setTimeout(stopEffectsVN, 201);
                clearInterval(interval);
                holdButtonReducer();
              }
                holdButtonReducerActive=true;
              }
            }
            function touchStart(){
              if(holdButtonActive.current){
              if((timerSet.current && timerActionOn.current) || !timerSet.current){
                if(sceneRef.current.style.display !== "none"){
                  stopEffectsVN();
                  setVolumeEffectsVN(0.2);
                  playEffectsVN(holding, false);
              }
                holdButtonReducerActive = false;
                clearInterval(reduceInterval);
                holdButtonHandler();
              }
            }
            }

            //sliderButton
            button = document.getElementById("slideButton");
            spans = sliderButtonRefCircleRef.current.querySelectorAll('span');
  button.addEventListener("mousedown", startDrag);
  button.addEventListener("touchstart", startDrag, { passive: false });

  document.addEventListener("mousemove", moveDrag);
  document.addEventListener("touchmove", moveDrag, { passive: false });

  document.addEventListener("mouseup", endDrag);
  document.addEventListener("touchend", endDrag);
  return () => {
    document.removeEventListener('deviceready', deviceReadyFunc, false);
    document.removeEventListener('backbutton', onBackButton, false);

    button1.removeEventListener("click", tapListener);

    holdButton.removeEventListener("mousedown", touchStart);
    holdButton.removeEventListener("touchstart", touchStart);
    holdButton.removeEventListener("mouseup", touchEnd);
    holdButton.removeEventListener("mouseleave", touchEnd);
    holdButton.removeEventListener("touchend", touchEnd);
    holdButton.removeEventListener("touchcancel", touchEnd);

    button.removeEventListener("mousedown", startDrag);
    button.removeEventListener("touchstart", startDrag, { passive: false });
    document.removeEventListener("mousemove", moveDrag);
    document.removeEventListener("touchmove", moveDrag, { passive: false });
    document.removeEventListener("mouseup", endDrag);
    document.removeEventListener("touchend", endDrag);
  }

  },[]);


  //actionButtons support functions
  function tapProgressReducer(){
    return new Promise(async (resolve, reject) => {
      for(let k=0;k<Infinity;k++){
        if(exit.current){
          return;
        }
    let frame = Math.floor(tapProgress/(1/25));
    if(tapProgress>0 && tapProgress<=0.5){
      if((Date.now() -lastTap) < 300){
        clicks-=0.35;
      }else{
        clicks-=2.3;
      }
    }
    if(tapProgress>0 && tapProgress>0.5){
      if((Date.now() -lastTap) < 300){
        clicks-=0.55;
      }else{
        clicks-=2.3;
      }
    }
    tapProgress = clicks / maxClicks;
    let indicator=tapProgress;
    if(tapProgress <= 1/25){
      indicator=0;
    }
    button1.style.setProperty("--scale", indicator);
    if(tapProgress<0){
      tapProgress = 0;
    }

    let animationShift = bgTappingRef.current.clientWidth/25;
    if(frame < 25){
      frame = Math.floor(tapProgress/(1/25));
      let framePosition = sceneBGPositionZero+(animationShift*frame*-1);
      bgTappingRef.current.style.transform = "translate("+framePosition+"px, 0)";
      bgTappingRef.current.style.filter = "brightness("+(0.9+tapProgress*0.15)+")";
    }
    if(tapping){
      await waitingFunc(70);
    }else{
      break;
    }
  }
  setTimeout(() => {
    resolve();
}, 400);
  return;
  });
  }

  function startTimer(time, buttonType, timeOutValue) {
    if(exit.current){
      return;
    }
           const timerTime = time;
           let timeLeft = timerTime;
           let progressBar = document.getElementById('progress'+buttonType);
           stopEffectsVN();
           setVolumeEffectsVN(0.5);
           playEffectsVN(timer, false);
           try{
             navigator.vibrate(0);
             navigator.vibrate([100, 70, 100]);
         }catch(e){
           console.log(e);
         }
           countDown();
           async function countDown() {
             if(exit.current){
               return;
             }
               if (timeLeft > 0) {
                   timeLeft-=0.1;
                   let widthPercentage = (timeLeft / timerTime) * 100;
                   if(timeLeft<0){
                     widthPercentage=0;
                   }
                   progressBar.style.width = widthPercentage + '%';
                   if (widthPercentage <= 30) {
                       progressBar.style.background = '#f04f4f';
                   } else {
                       let transitionColor = "#efb461";
                       progressBar.style.background = transitionColor;
                   }
               }

                if(timeLeft<=0){
                  try{
                    navigator.vibrate(700);
                }catch(e){
                  console.log(e);
                }
                 progressBar.style.width = '0%';
                 timerOn.current = false;
                 if(buttonType == "Tap"){
                   button1.style.transition = "0.3s ease";
                   button1.style.color = "#e71c1c";
                   button1.style.boxShadow = "0 0 0 0 rgba(231, 28, 28, .3)";
                 }

                   if(buttonType == "Tap"){
                     changeSetting(tapButtonRef,"current.style.opacity", 0, "", 0.02);
                   }else if(buttonType =="Text"){
                     await changeSetting(timerText,"current.style.opacity", 0, "", 0.02);
                     timerText.current.style.display = "none";
                     answerHandler(undefined, numI.current, numJ.current, timeOutValue);
                   }
                   progressBar.style.width = '99%';
               }
               if(timerOn.current){
                 setTimeout(countDown, 100);
               }
           }
       }

//hold button
function holdButtonHandler(){
    interval = setInterval(() => {
      if(exit.current){
        return;
      }
        holdProgress+=150/3000;
        holdButton.style.setProperty("--scale", holdProgress);
        if(sceneRef.current.style.display !== "none"){
          sceneRef.current.style.filter = "saturate("+(0.5+holdProgress/3.5)+")";
        }
        //if(sceneRefVid.current.style.display !== "none"){
          //sceneRefVid.current.style.filter = "saturate("+(0.5+holdProgress/3.5)+")";
        //}
        if (holdProgress >= 1) {
          if(sceneRef.current.style.display !== "none"){
          changeSetting(sceneRef,"current.style.filter", 1, "", 0.01, false,true, false, "saturate");
        }
      //  if(sceneRefVid.current.style.display !== "none"){
        //  changeSetting(sceneRefVid,"current.style.filter", 1, "", 0.01, false,true, false, "saturate");
        //}
        if(actionSound.current !== undefined && actionSound.current !== false){
          stopEffectsVN();
          setVolumeEffectsVN(actionSound.current[1]);
          if(actionSound.current[2]){
            setTimeout(() =>{
              playEffectsVN(actionSound.current[0], false)
            }, actionSound.current[2]);
          }else{
            playEffectsVN(actionSound.current[0], false);
          }
        }else if(actionSound.current == false){

        }else{
          stopEffectsVN();
          setVolumeEffectsVN(0.3);
          playEffectsVN(licking, false);
        }
          try{
          navigator.vibrate(50);
        }catch(e){
          console.log(e);
        }
          timerActionOn.current = false;
          holdButtonActive.current = false;
          holdButtonComplete.current = true;
          holdButton.style.transition = "transform 0.2s ease";
          holdButton.style.color = "#00cf14";
          holdButton.style.background = "rgba(0, 135, 13, 0.7)";
          holdButton.style.boxShadow = "0 0 0 0 rgba(0, 135, 13, .7)";
          setTimeout(async () => {
          await changeSetting(holdButtonRef,"current.style.opacity", 0, "", 0.02);
          actionButtons.current.style.display = "none";
          holdButtonRef.current.style.display = "none";
          holdButton.style.transition = "";
          holdButton.style.color = "#dd9d00";
          holdButton.style.background = "rgba(255, 255, 255, .7)";
          holdButton.style.boxShadow = "0 0 0 0 rgba(255, 255, 255, .7)";
        }, 100);
            clearInterval(interval);
            holdProgress=0;
        }
    }, 100);
}
function holdButtonReducer(){
    reduceInterval = setInterval(() => {
      if(exit.current){
        return;
      }
        holdProgress-=300/3000;
        holdButton.style.setProperty("--scale", holdProgress);
        if(holdProgress>=0){
          if(sceneRef.current.style.display !== "none"){
            sceneRef.current.style.filter = "saturate("+(0.5+holdProgress/3.5)+")";
          }
        //  if(sceneRefVid.current.style.display !== "none"){
        //    sceneRefVid.current.style.filter = "saturate("+(0.5+holdProgress/3.5)+")";
        //  }
        }
        if (holdProgress <= 0) {
            clearInterval(reduceInterval);
            holdProgress=0;
            holdButton.style.setProperty("--scale", holdProgress);
        }
    }, 100);
}

 function holdWaiter(){
   if(exit.current){
     return;
   }
  return new Promise(async (resolve, reject) => {
while(holdButtonComplete.current == false){
await waitingFunc(100);
}
holdButtonComplete.current = false;
resolve();
});
}

//slider button
function startDrag(e) {
  if(exit.current){
    return;
  }
      dragging.current = true;
      let moveEvent = e.touches ? e.touches[0] : e;
      startPos.current = (directionSlider.current === "left" || directionSlider.current === "right") ? moveEvent.clientX : moveEvent.clientY;
  }
let readyVibration = false;
  function moveDrag(e) {
    if(exit.current){
      return;
    }
    if (dragging.current) {
      e.preventDefault();
      let moveEvent = e.touches ? e.touches[0] : e;
      let clientPosition = moveEvent.clientX;

      if (directionSlider.current === "down" || directionSlider.current === "up") {
          clientPosition = moveEvent.clientY;
      }

            if (directionSlider.current === "down" || directionSlider.current === "right") {
                 targetPos.current = Math.max(0, Math.min(clientPosition - startPos.current, pathLength.current));
             } else if (directionSlider.current === "up" || directionSlider.current === "left") {
                 targetPos.current = Math.max(0, Math.min(startPos.current - clientPosition, pathLength.current));
             }

             if(directionSlider.current === "up" || directionSlider.current === "left"){
                targetPos.current*=-1;
            }
      animateButton();
  }
}

function animateButton() {
  if(exit.current){
    return;
  }
  cancelAnimationFrame(animationFrameId.current);
  function step() {
    if(exit.current){
      return;
    }
      if(dragging.current){
        let progress = Math.abs(currentPosition.current / pathLength.current);
        if(currentPosition.current > pathLength.current*0.7){
          currentPosition.current += (targetPos.current - currentPosition.current) * sliderDifficulty.current;
        }else{
          currentPosition.current += (targetPos.current - currentPosition.current) * 0.1;
        }

      let transformValue = (directionSlider.current === "down" || directionSlider.current === "up")
          ? "translateY(" + currentPosition.current + "px)"
          : "translateX(" + currentPosition.current + "px)";

      button.style.transform = transformValue;
      let gradientDirection = (directionSlider.current === "right")
                 ? "to right"
                 : (directionSlider.current === "left")
                     ? "to left"
                     : (directionSlider.current === "up")
                     ? "to top"
                     : "to bottom"

             button.style.background = "linear-gradient(" + gradientDirection + ", rgba(255, 255, 255, 0.9) " + (progress * 100) + "%, rgba(255, 255, 255, 0.7) " + (progress * 100) + "%)";

      if (Math.abs(targetPos.current - currentPosition.current) > 0.5) {
            animationFrameId.current = requestAnimationFrame(step);
            //scheduleFrameTask(step);
      }
      if (Math.abs(currentPosition.current) > pathLength.current * 0.98) {
        if(!readyVibration){
          stopEffectsVN();
          setVolumeEffectsVN(0.08);
          playEffectsVN(complete, false);
          try{
          navigator.vibrate(0);
          navigator.vibrate(50);
        }catch(e){
          console.log(e);
        }
          readyVibration = true;
        }
        spans[0].style.borderBottom = "2px solid #16c826";
        spans[0].style.borderRight = "2px solid #16c826";
        spans[1].style.borderBottom = "2px solid #16c826";
        spans[1].style.borderRight = "2px solid #16c826";
        spans[2].style.borderBottom = "2px solid #16c826";
        spans[2].style.borderRight = "2px solid #16c826";
        button.style.transition = "0.3s";
        button.style.background = "rgba(0, 135, 13, 0.3)";
        button.style.border = "2px solid #16c826";
      }else{
        readyVibration = false;
        spans[0].style.borderBottom = "2px solid #b38116";
        spans[0].style.borderRight = "2px solid #b38116";
        spans[1].style.borderBottom = "2px solid #b38116";
        spans[1].style.borderRight = "2px solid #b38116";
        spans[2].style.borderBottom = "2px solid #b38116";
        spans[2].style.borderRight = "2px solid #b38116";
        button.style.border = "2px solid #b38116";
        button.style.transition = "none";
      }
    }
  }
  step();
  }

  async function endDrag() {
    return new Promise(async (resolve, reject) => {
    if(exit.current){
      return;
    }
    if(dragging.current){
      dragging.current = false;
cancelAnimationFrame(animationFrameId.current);
      if (Math.abs(currentPosition.current) < pathLength.current * 0.98) {
          button.style.transition = "transform 0.5s ease";
          button.style.transform = "translate(0, 0)";
          button.style.background = "rgba(255, 255, 255, 0.7)";
          currentPosition.current = 0;
      }else {
        while(isPlayingEffectsVN){
          await waitingFunc(50);
        }
        if(actionSound.current !== undefined && actionSound.current !== false){
          stopEffectsVN();
          setVolumeEffectsVN(actionSound.current[1]);
          if(actionSound.current[2]){
            setTimeout(() =>{
              playEffectsVN(actionSound.current[0], false)
            }, actionSound.current[2]);
          }else{
            playEffectsVN(actionSound.current[0], false);
          }
        }else if(actionSound.current == false){

        }else{
          stopEffectsVN();
          setVolumeEffectsVN(0.3);
          playEffectsVN(licking, false);
        }
        try{
        navigator.vibrate(0);
        navigator.vibrate(50);
      }catch(e){
        console.log(e);
      }
          button.style.transition = "transform 0.6s ease";
          if(directionSlider.current === "up" || directionSlider.current === "left"){
            pathLength.current*=-1;
          }
          let transformValue = (directionSlider.current === "down" || directionSlider.current === "up")
              ? "translateY(" + pathLength.current + "px)"
              : "translateX(" + pathLength.current + "px)";

          button.style.transform = transformValue;
          sliderButtonComplete.current = true;
          timerActionOn.current = false;
          await changeSetting(sliderButtonRef,"current.style.opacity", 0, "", 0.02);
          button.style.transition = "none";
          sliderButtonRef.current.style.display = "none";
          actionButtons.current.style.display = "none";
          currentPosition.current = 0;
          spans[0].style.borderBottom = "2px solid #b38116";
          spans[0].style.borderRight = "2px solid #b38116";
          spans[1].style.borderBottom = "2px solid #b38116";
          spans[1].style.borderRight = "2px solid #b38116";
          spans[2].style.borderBottom = "2px solid #b38116";
          spans[2].style.borderRight = "2px solid #b38116";
          button.style.border = "2px solid #b38116";
          button.style.transform = "translate(0, 0)";
          button.style.background = "rgba(255, 255, 255, 0.7)";
      }

      setTimeout(function() {
          button.style.transition = "";
      }, 600);
    }
    resolve();
  });
  }

  function sliderWaiter(){
   return new Promise(async (resolve, reject) => {
 while(sliderButtonComplete.current == false){
 await waitingFunc(100);
 }
 resolve();
 });
 }

 //Action timer(Hold + Slide)
 function startActionTimer(time, buttonType) {
   if(exit.current){
     return;
   }
          const timerTime = time;
          let timeLeft = timerTime;
          let progressBar = document.getElementById('progressAction');
          spans = sliderButtonRefCircleRef.current.querySelectorAll('span');
          button = document.getElementById("slideButton");
          let holdButton = document.querySelector(".holdButton");
          countDown();
          async function countDown() {
            if(exit.current){
              return;
            }
              if (timeLeft > 0) {
                  timeLeft-=0.1;
                  let widthPercentage = (timeLeft / timerTime) * 100;
                  if(timeLeft<0){
                    widthPercentage=0;
                  }
                  progressBar.style.width = widthPercentage + '%';

                  if (widthPercentage <= 30) {
                      progressBar.style.background = '#f04f4f';
                  } else {
                      let transitionColor = "#efb461";
                      progressBar.style.background = transitionColor;
                  }
              }

              if(timeLeft<=0 && timerActionOn.current){
                progressBar.style.width = '0%';
                timerActionOn.current = false;
                if(buttonType == "Slider"){
                  if (Math.abs(currentPosition.current) > pathLength.current * 0.98) {
                    await endDrag();
                    timerAction.current.style.display = "none";
                    progressBar.style.width = "100%";
                    progressBar.style.background = "#efb461";
                    return;
                  }
                  dragging.current = false;
                  spans[0].style.borderBottom = "2px solid #b38116";
                  spans[0].style.borderRight = "2px solid #b38116";
                  spans[1].style.borderBottom = "2px solid #b38116";
                  spans[1].style.borderRight = "2px solid #b38116";
                  spans[2].style.borderBottom = "2px solid #b38116";
                  spans[2].style.borderRight = "2px solid #b38116";
                  button.style.transition = "0.1s";
                  button.style.background = "rgba(231, 28, 28, .3)";
                  button.style.border = "2px solid #b38116";
                }else if(buttonType == "Hold"){
                  holdButtonComplete.current = true;
                  holdButtonActive.current = false;
                  clearInterval(reduceInterval);
                  clearInterval(interval);
                  holdButton.style.transition = "0.1s ease";
                  holdButton.style.background = "rgba(231, 28, 28, 0.7)";
                  holdButton.style.color = "#e71c1c";
                  holdButton.style.boxShadow = "0 0 0 0 rgba(231, 28, 28, .3)";
                }
                stopEffectsVN();
                setVolumeEffectsVN(0.4);
                playEffectsVN(failed, false);
                try{
                navigator.vibrate(700);
              }catch(e){
                console.log(e);
              }
                  //disappearing
                  if(buttonType == "Hold"){
                    await changeSetting(actionButtons,"current.style.opacity", 0, "", 0.02);
                    actionButtons.current.style.display = "none";
                    holdButtonRef.current.style.display = "none";
                    holdButton.style.transition = "";
                    holdButton.style.color = "#dd9d00";
                    holdButton.style.background = "rgba(255, 255, 255, .7)";
                    holdButton.style.boxShadow = "0 0 0 0 rgba(255, 255, 255, .7)";
                    holdProgress=0;
                    //if(sceneRefVid.current.style.display !== "none"){
                      //changeSetting(sceneRefVid,"current.style.filter", 1, "", 0.01, false,true, false, "saturate");
                  //  }
                    if(sceneRef.current.style.display !== "none"){
                      changeSetting(sceneRef,"current.style.filter", 1, "", 0.01, false,true, false, "saturate");
                    }
                  }else if(buttonType =="Slider"){
                    sliderButtonComplete.current = true;
                    await changeSetting(actionButtons,"current.style.opacity", 0, "", 0.02);
                    button.style.transition = "none";
                    sliderButtonRef.current.style.display = "none";
                    actionButtons.current.style.display = "none";
                    currentPosition.current = 0;
                    spans[0].style.borderBottom = "2px solid #b38116";
                    spans[0].style.borderRight = "2px solid #b38116";
                    spans[1].style.borderBottom = "2px solid #b38116";
                    spans[1].style.borderRight = "2px solid #b38116";
                    spans[2].style.borderBottom = "2px solid #b38116";
                    spans[2].style.borderRight = "2px solid #b38116";
                    button.style.border = "2px solid #b38116";
                    button.style.transform = "translate(0, 0)";
                    button.style.background = "rgba(255, 255, 255, 0.7)";
                  }
                  achievementCondition.current = false;
                  setSaveAchievementCondition(previous => previous + 1);
              }
              if(timerActionOn.current){
                setTimeout(countDown, 100);
              }else{
                timerAction.current.style.display = "none";
                progressBar.style.width = "100%";
                progressBar.style.background = "#efb461";
              }
          }
      }

  useEffect(() => {
    f();
    let tick;
    async function f(){
    if(state.current[step] == undefined){
      state.current.splice(step, 1, {numI:numI.current, numJ:numJ.current, savedAnswers:JSON.stringify([])})
    }
    if(state.current[step]["numI"]){
      numI.current = state.current[step]["numI"];
    }else{
      numI.current = 0;
    }
    if(state.current[step]["numJ"]){
      numJ.current = state.current[step]["numJ"];
    }else{
      numJ.current = 0;
    }
    if(state.current[step]["savedAnswers"]){
       savedAnswers.current = JSON.parse(state.current[step]["savedAnswers"]);
    }else{
      savedAnswers.current = [];
    }
    if(startCoordinates !== undefined){
      wrap.current.style.background = "#fff";
      wrap.current.style.opacity = 1;
      wrap.current.style.zIndex = 10;
      currentBg.current = bgRef.current;
      currentBg.current.src = background;
      if(plot[0].scene && plot[0].img && numI.current == 0){
        if(plot[0].img.includes(".mp4")){
          sceneRefVid.current.style.display = "block";
          sceneRefVid.current.src = plot[0].img;
          await waitVideoReady(sceneRefVid.current, true);
          if(sceneRefVid.current.clientWidth-document.body.clientWidth>0){
            sceneRefVid.current.style.height = "100vh";
            sceneRefVid.current.style.width = "auto";
            sceneRefVid.current.style.transform = "translate("+(-1*(sceneRefVid.current.clientWidth-document.body.clientWidth)/2)+"px, 0)";
          }else{
            sceneRefVid.current.style.width = "100vw";
            sceneRefVid.current.style.height = "auto";
            sceneRefVid.current.style.transform = "translate(0, "+(-1*(sceneRefVid.current.clientHeight-document.body.clientHeight)/2)+"px)";
          }
        }else{
          await new Promise((resolve, reject) => {
              const img = new Image();
              img.onload = () => {
                cachedImgs.current.set(plot[0].img, img);
                resolve(img);
              };
              img.onerror = () => {
                reject(new Error('Failed to load ' + plot[0].img));
              };
              img.src = plot[0].img;
              if (img.complete) {
                cachedImgs.current.set(plot[0].img, img);
                resolve(img);
              }
            });
          sceneRef.current.style.display = "block";
          sceneRef.current.style.backgroundImage = "url("+plot[0].img+")";
          await waitBGImg(false);
        }
      }else{
        await waitBGImg(false);
      }
      let lowing = currentBg.current.naturalHeight/document.body.clientHeight;
      let maxPointPX = currentBg.current.naturalWidth/lowing - document.body.clientWidth-5;
      let maxPointVW = maxPointPX/document.body.clientWidth;
      currentBg.current.style.transform = "translateX("+Math.round(startCoordinates * maxPointPX/100 * -1)+"px)";
    }
    const start = performance.now();
    tick = setInterval(() => {
      if(performance.now() - start > 2500){
          loadingPic.current.style.display = "block";
      }
    }, 300);
    await loadImgs();
    await initialImgsLoad();
    textBoxLeft.current.style.transform = "translate("+(-0.5)*document.body.clientWidth+"px, "+(-0.2)*document.body.clientHeight+"px)";
    textBoxRight.current.style.transform = "translate("+(0.5)*document.body.clientWidth+"px, "+(-0.2)*document.body.clientHeight+"px)";
    if(numI.current == 0 && numJ.current == 0){
      gameStart(0,0);
    }else{
      gameStart(0,0, true);
    }
    for(let v =0;v<Infinity;v++){
      await waitingFunc(50, true);
      if(!loading.current){
        break;
      }
    }
    clearInterval(tick);
    await changeSetting(wrap,"current.style.opacity", 0, "", 0.01, false, false, true);
    loadingPic.current.style.display = "none";
    if(hintUsedVar.current == "hide"){
      backMenuAppear("firstTime");
      if(isLS){
      localStorage.setItem('hintUsedVarSC2', "true");
    }
    }
    }
    return () => {
    clearInterval(tick);
    }
},[]);

useEffect(() => {
  if(!loading.current){
    state.current.splice(step, 1, {numI:numI.current, numJ:numJ.current, savedAnswers:JSON.stringify(savedAnswers.current)})
    if(isLS){
    localStorage.setItem('stateSC2', JSON.stringify(state.current));
  }
  }
},[save]);

useEffect(() => {
  if(!loading.current){
    if(isLS){
    localStorage.setItem('phoebesComfort2', JSON.stringify(phoebesComfort.current));
  }
  }
},[savePhoebesComfort]);

useEffect(() => {
  if(!loading.current){
    if(isLS){
    localStorage.setItem('achievementCondition2', JSON.stringify(achievementCondition.current));
  }
  }
},[saveAchievementCondition]);

useEffect(() => {
  if(!loading.current){
    if(isLS){
    localStorage.setItem('achievementsSave2', JSON.stringify(achievementsSave.current));
  }
  }
},[saveAchievements]);

useEffect(() => {
  if(!loading.current){
    if(isLS){
    localStorage.setItem('gallerySC2', JSON.stringify(gallerySC.current));
  }
  }
},[saveGallerySC]);

async function goToMenu(){
  document.getElementById("backWrapVNId").style.zIndex = 9;
  changeMusicSpeed(1);
  changeAmbientSpeed(1);
  transitionVolumeAmbient(0,300);
  transitionVolumeEffectsVN(0,300);
  transitionVolumeEffects(0,300);
  await transitionVolume(0,300);
  stopEffectsVN();
  stopMusic();
  stopAmbient();
  stopEffects();
  setVolumeEffects(0.5);
  playEffects(whoosh, false);
  wrap.current.style.zIndex = 10;
  await changeSetting(wrap,"current.style.opacity", 1, "", 0.02);
  try{
  navigator.vibrate(0);
}catch(e){
  console.log(e);
}
  exit.current=true;
  goMenu();
  return;
}

async function nextNovel(endOfChapter){
  wrap.current.style.zIndex = 10;
  if(!musicContinue){
    changeMusicSpeed(1);
    changeAmbientSpeed(1);
    transitionVolumeAmbient(0,300);
    transitionVolumeEffectsVN(0,300);
    transitionVolumeEffects(0,300);
    await transitionVolume(0,300);
    stopEffectsVN();
    stopMusic();
    stopAmbient();
    stopEffects();
  setVolumeEffects(0.5);
  if(endOfChapter){
    playEffects(chapterCompleted, false);
  }else{
    playEffects(whoosh, false);
  }
  }
  await changeSetting(wrap,"current.style.opacity", 1, "", 0.02);
  try{
  navigator.vibrate(0);
}catch(e){
  console.log(e);
}
  exit.current=true;
  await waitingFunc(600);
  if(nextStep.current>1){
    for(let k=0;k<nextStep.current;k++){
      if(state.current[step+k] == undefined){
        state.current.splice(step+k, 1, null);
      }
    }
  }
  goNext(nextStep.current);
  return;
}

function initialImgsLoad(){
  return new Promise(async (resolve, reject) => {
  let loaded = 0;
  const images = document.querySelectorAll("img");
  images.forEach(async (img) => {
    if(img.complete){
      loaded++;
      if(loaded == images.length){
        resolve();
      }
    }else{
      img.onload = async () =>{
        loaded++;
        if(loaded == images.length){
          resolve();
        }
      }
      setTimeout(() => {resolve()}, 2000);
    }
  });
});
}

function loadImgs(){
  const urls = new Array();

for(let i=numI.current;i<plot.length;i++){
  if(plot[i]["changeBGTransition"] && window[plot[i]["changeBGTransition"]] == undefined){
    urls.push(plot[i]["changeBGTransition"]);
}
  if(plot[i]["img"] && window[plot[i]["img"]] == undefined){
    urls.push(plot[i]["img"]);
}
if(plot[i]["img2"] && window[plot[i]["img2"]] == undefined){
  urls.push(plot[i]["img2"]);
  }
  if(plot[i]["phrases"]){
    for(let j=0;j<plot[i]["phrases"].length;j++){
      if(plot[i]["phrases"][j]["emotion"] && window[plot[i]["phrases"][j]["emotion"]] == undefined){
        urls.push(plot[i]["phrases"][j]["emotion"]);
      }
    }
  }
}
if (urls.length === 0) return Promise.resolve([]);
 const preLoad = urls.slice(0,5);
 const afterLoad = urls.slice(5, urls.length);
const promises = preLoad.map(src => new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => {
      cachedImgs.current.set(src, img);
      resolve(img);
    };

    img.onerror = () => {
      reject(new Error('Failed to load ' + src));
    };
    if(!cachedImgs.current.has(src) && !src.includes(".mp4")){
      img.src = src;
    }else if(src.includes(".mp4") && !cachedImgs.current.has(src)){
      const video = document.createElement('video');
      video.preload = 'auto';
      video.muted = true;
      video.style.display = 'none';
      document.body.appendChild(video);
      video.src = src;
      const onReady = () => {
        cachedImgs.current.set(src, video);
        cleanup();
        resolve();
      };
      const onError = () => {
        console.error('Failed to load', src);
        cleanup();
        resolve();
      };
      const cleanup = () => {
        video.removeEventListener('canplaythrough', onReady);
        video.removeEventListener('loadeddata', onReady);
        video.removeEventListener('error', onError);
         document.body.removeChild(video);
      };
      video.addEventListener('canplaythrough', onReady, { once: true });
      video.addEventListener('loadeddata', onReady, { once: true });
      video.addEventListener('error', onError, { once: true });
      if (video.readyState >= 3) {
        onReady();
      }
    }else{
      resolve();
    }

    if(img.complete) {
      cachedImgs.current.set(src, img);
      resolve(img);
    }
  }));


  afterLoad.map(src => {
      const img = new Image();
      img.onload = () => {
        cachedImgs.current.set(src, img);
      };

      img.onerror = () => {
        console.log('Failed to load ' + src);
      };
      if(!cachedImgs.current.has(src) && !src.includes(".mp4")){
        img.src = src;
      }else if(src.includes(".mp4")){
        const video = document.createElement('video');
        video.preload = 'auto';
        video.muted = true;
        video.style.display = 'none';
        document.body.appendChild(video);
        video.src = src;
        const onReady = () => {
          cachedImgs.current.set(src, video);
          cleanup();
        };
        const onError = () => {
          console.error('Failed to load', src);
          cleanup();
        };
        const cleanup = () => {
          video.removeEventListener('canplaythrough', onReady);
          video.removeEventListener('loadeddata', onReady);
          video.removeEventListener('error', onError);
           document.body.removeChild(video);
        };
        video.addEventListener('canplaythrough', onReady, { once: true });
        video.addEventListener('loadeddata', onReady, { once: true });
        video.addEventListener('error', onError, { once: true });
        if (video.readyState >= 3) {
          onReady();
        }
      }

      if (img.complete) {
        cachedImgs.current.set(src, img);
      }
    });

  return Promise.all(promises);
}

function waitingFunc(t, loadStop){
  return new Promise(async (resolve, reject) => {
    if(!loading.current || loadStop){
      setTimeout(f,t);
    }else{
      f();
    }
    function f(){
      resolve();
      return;
    }
  });
}

async function waitin(){
  if(exit.current){
    return;
  }
  if(loading.current){
    return;
  }
  return new Promise((resolve, reject) => {
document.getElementById("wrap").onclick = ff;
function ff(){
  if(!animation.current && !charAppearing.current && !texting.current){
  document.getElementById("wrap").onclick = null;
  resolve();
  return;
}
}
});
return;
}

async function waitBGImg(skip){
  if(skip){
    return;
  }
  return new Promise(async (resolve, reject) => {
    let loaded = false;
    while(!loaded) {
checkifPicLoaded();
await waitingFunc(16);
}
resolve();
    async function checkifPicLoaded(){
      if(exit.current){
        return;
      }
        if(!bgRef.current.complete || (bgRef.current.naturalWidth < 1) || (bgRef.current.naturalHeight < 1)){
          return;
        }else{
          await waitingFunc(16);
          loaded=true;
          return;
        }
      }
});
}

async function waitBGUnderImg(skip, stopLoad){
  if(skip){
    return;
  }
  return new Promise(async (resolve, reject) => {
    let loaded = false;
    while(!loaded) {
checkifPicLoaded();
await waitingFunc(8, stopLoad);
}
resolve();
    async function checkifPicLoaded(){
      if(exit.current){
        return;
      }
        if(!bgRefUnder.current.complete || (bgRefUnder.current.naturalWidth < 1) || (bgRefUnder.current.naturalHeight < 1)){
          return;
        }else{
          await waitingFunc(8, stopLoad);
          loaded=true;
          return;
        }
      }
});
}

function skipText(){
if(arrowBackVisible.current){
  clearTimeout(arrowBackVisible.current);
  backMenuDisappear();
}
  if(texting.current){
    if(skipButton.current){
      stopTexting.current = true;
      skipButton.current = false;
    }
}
}

function speedUpGame(){
  if(!charAppearing.current && ! preCharAppearing.current){
      speedUp.current = true;
  }
}


async function scheduleFrameTask(fn) {
  frameTasks.current.push(fn);
  if (!rafScheduled.current) {
    rafScheduled.current = true;
    let fpsInterval = 1000/Math.round(100/hzAdjuster);
    animate();
    function animate(now) {
      if(rafScheduled.current){
        requestAnimationFrame(animate);
      }
        var elapsed = now - lastDrawTime.current;

        if (elapsed > fpsInterval) {
            lastDrawTime.current = now - (elapsed % fpsInterval);
            rafScheduled.current = false;
            const tasks = frameTasks.current.splice(0, frameTasks.current.length);
            let nowText = false;
            for (let i=0; i< tasks.length; i++){
              tasks[i]();
            }
        }
    }

  }
}

function moveBgTo(point, coef, character, emotion, position, text, answers, timer, noBlur, destinationPoint, appearAfterMoving, changeBGTransition, transitionMode, firstIteration){
  if(exit.current){
    return;
  }
  coef=Math.round(60*coef*(100/hzAdjuster/100));
  if(transitionMode == undefined){
    transitionMode = "fast";
  }
  return new Promise(async (resolve, reject) => {
    try{
      if(!bgRefSave.current){
        bgRefSave.current = [currentBg.current.naturalHeight,currentBg.current.naturalWidth];
      }
      let lowing = bgRefSave.current[0]/document.body.clientHeight;
      let maxPointPX = bgRefSave.current[1]/lowing - document.body.clientWidth-5;
      let maxPointVW = maxPointPX/document.body.clientWidth;
      point = maxPointPX/100 * point * -1;
      if(loading.current){
        if((removeChar.current !== false) && firstIteration){
          changeSetting(particles,"current.style.opacity", 0.1, "", 0.02,false,true);
          changeSetting(currentBg,"current.style.filter", 0, "", 1.4*2/(Math.abs(character.initialPointX[0]-character.destinationPointX)/character.speed),false,true);
          if (removeCharPosition.current == position){
            await disappearing(removeChar.current, removeCharPosition.current, destinationPoint);
          }else{
            disappearing(removeChar.current, removeCharPosition.current, destinationPoint);
          }
      }
        currentBg.current.style.transform = "translateX("+Math.round(point)+"px)";
      if(changeBGTransition){
        changeBG(changeBGTransition, true);
      }
        await appearing(character, emotion, position, text, answers, timer, noBlur, destinationPoint);
        resolve();
        return;
      }

      changeSetting(particles,"current.style.opacity", 0.05, "", 0.02,false, true);
  let preI = currentBg.current.style.transform.split("translateX(")[1];
  let i = Math.fround(preI.split("px")[0]);
  let finalPos;
  let startPos = i;
  const endPos = point;
  let dx = endPos - startPos;
      let distance = Math.abs(dx);
      let wholeDistPecent = distance/(currentBg.current.naturalWidth/lowing);
      const direction = dx >= 0 ? 1 : -1;
      let targetSpeed = 1;
      let T;
      let positionFunction;
      if (transitionMode === "slow") {
      T = distance / (0.75 * targetSpeed);
      positionFunction = function(p) {
        let x;
        if (p <= 0.2) {
          x = (targetSpeed * T * p * p) / 0.4;
        } else if (p <= 0.7) {
          let x0 = 0.1 * targetSpeed * T;
          x = x0 + targetSpeed * T * (p - 0.2);
        } else {
          let x1 = 0.6 * targetSpeed * T;
          let u = (p - 0.7) / 0.3;
          let x_dec = 0.3 * targetSpeed * T * (u - 0.5 * u * u);
          x = x1 + x_dec;
        }
        return (x > distance) ? distance : x;
      };

    } else if (transitionMode === "fast") {
      T = 2 * distance / targetSpeed;
      positionFunction = function(p) {
        let x;
        if (p <= 0.7) {
          x = (targetSpeed * T * p * p) / 1.4;
        } else {
          let x1 = 0.35 * targetSpeed * T;
          let u = (p - 0.7) / 0.3;
          let x_dec = 0.3 * targetSpeed * T * (u - 0.5 * u * u);
          x = x1 + x_dec;
        }
        return (x > distance) ? distance : x;
      };
    }
  let appearenceIterations, pathLength;
  if(destinationPoint){
    pathLength = character.initialPointX[0]-destinationPoint[0];
    appearenceIterations = Math.round(parseFloat(Math.abs(pathLength)/(character.speed*2.3*hzAdjuster)));
  }else{
    pathLength = character.initialPointX[0]-character.destinationPointX;
    appearenceIterations = Math.round(parseFloat(Math.abs(pathLength)/(character.speed*2.3*hzAdjuster)));
  }
  let overlap = Math.round(5*(100/hzAdjuster/100));
  let appearencePoint=false;
  if(!appearAfterMoving && position !== "center"){
    appearencePoint = coef-appearenceIterations-overlap;
  }
  if(position == "center"){
    appearAfterMoving = true;
  }
        let positions = [];
        for (let i = 0; i <= coef; i++) {
          let p = i / coef;
          positions.push(positionFunction(p));
        }
        let currentIndex = 0;
        document.getElementById("wrap").onclick = speedUpGame;
        lastDrawTime.current = performance.now();
        animate();
        async function animate() {
          if(exit.current){
            return;
          }
          if((removeChar.current !== false) && firstIteration && currentIndex==2){
            changeSetting(currentBg,"current.style.filter", 0, "", 1.5*2/(Math.abs(character.initialPointX[0]-character.destinationPointX)/character.speed),false,true);
            if (removeCharPosition.current == position){
              await disappearing(removeChar.current, removeCharPosition.current, destinationPoint);
            }else{
              disappearing(removeChar.current, removeCharPosition.current, destinationPoint);
            }
        }
          if(speedUp.current && !speedUpIterations.current && (currentIndex<appearencePoint || appearAfterMoving)){
            let charSpeed = character.speed*2.3*hzAdjuster;
            let iterationsCounterChar = 0;
            let init = parseInt(character.initialPointX[0]);
            let dP;
            if(destinationPoint){
              dP = destinationPoint[0];
            }else{
              dP = character.destinationPointX;
            }
            for(let g = 0;g<Infinity;g++){
              iterationsCounterChar++;
                if(init<dP){
                    charSpeed*=1.04;
                      init+=charSpeed;
                      if(init>=dP){
                        break;
                      }
                    }else if(init>dP){
                      charSpeed*=1.04;
                      init-=charSpeed;
                      if(init<=dP){
                        break;
                      }
                    }
                  }

                  let computedPos = positions[currentIndex];
                  let actualPos = startPos + (computedPos * direction);
                  startPos=actualPos;
                  dx = endPos - startPos;
                  distance = Math.abs(dx);
                    coef=Math.round((coef-currentIndex)*iterationsCounterChar/appearenceIterations);
                    positions = [];
                    for(let i = 0; i<frameTasks.current.length; i++){
                      if(String(frameTasks.current[i]).includes("animate()")){
                        frameTasks.current.splice(i, 1);
                      }
                    }
                  for (let i = 0; i <= coef; i++) {
                    let p = i / coef;
                    positions.push(positionFunction(p));
                  }
                  coef = positions.length;
                  if(!appearAfterMoving && position !== "center"){
                      appearencePoint = coef - iterationsCounterChar-2;
                      if(appearencePoint<0){
                        appearencePoint=0;
                      }
                  }
                  currentIndex = 0;
                  speedUpIterations.current = true;

                    animate();

                  return;

                  /*if(null){
                    requestAnimationFrame(animate);
                    return;
                  finalPos = positions[positions.length-1];
                  let increaser=1.02;
                  for (let i = parseInt(currentIndex); i <= positions.length; i++) {
                    positions[i] = positions[i]*increaser;
                    if((positions[i] - positions[i-1]) < 7-2*(distance/(bgRef.current.naturalWidth/lowing))){
                      increaser*=1.02;
                    }
                    if(positions[i]>=finalPos){
                      positions[i] = finalPos;
                      positions.splice(i+1, positions.length-i-1);
                      break;
                    }
                  }
                  coef = positions.length;
                  if(!appearAfterMoving && position !== "center"){
                    appearencePoint = coef - iterationsCounterChar;
                  }
                  speedUpIterations.current = true;
                  requestAnimationFrame(animate);
                  return;
                }*/
              }
          if (currentIndex < positions.length) {
            let computedPos = positions[currentIndex];
            let actualPos = startPos + (computedPos * direction);
            function animBg(){
              currentBg.current.style.transform = "translateX("+Math.round(actualPos)+"px)";
              animate();
            }
            currentIndex++;
            if(currentIndex>coef*0.15){
            preCharAppearing.current = true;
            }
            if(currentIndex == appearencePoint && !appearAfterMoving){
              appearing(character, emotion, position, text, answers, timer, noBlur, destinationPoint);
            }

              scheduleFrameTask(animBg);
              return;
          } else {
            if(appearAfterMoving || position == "center"){
              appearing(character, emotion, position, text, answers, timer, noBlur, destinationPoint);
            }
            if(changeBGTransition){
              changeBG(changeBGTransition, true);
            }
            speedUpIterations.current = false;
            preCharAppearing.current = false;
            resolve();
            return;
          }
        }

}catch(e){
console.log(e)
}
});
}

function disappearing(char, position, destinationPoint){
  if(exit.current){
    return;
  }
  return new Promise(async (resolve, reject) => {
  if(position == "left"){
      await setCharParameters(charRefLeft,"current.style.transform", char.initialPointX[0], char.initialPointX[1], char.speed,charRefLeft,"current.style.transform", char.initialPointY[0], char.initialPointY[1], charRefLeft,"current.style.opacity", 0, "", char, position);
    charRefLeft.current.src = "";
  }else if(position == "right"){
        await setCharParameters(charRefRight,"current.style.transform", char.initialPointX[0], char.initialPointX[1], char.speed,charRefRight,"current.style.transform", char.initialPointY[0], char.initialPointY[1], charRefRight,"current.style.opacity", 0, "", char, position);
    charRefRight.current.src = "";
  }else{
    resolve();
    return;
  }
  resolve();
});
}
async function appearing(char, emotion, position, text, answers, timer, noBlur, destinationPoint){
  if(exit.current){
    return;
  }
  charAppearing.current=true;
    return new Promise(async (resolve, reject) => {
      if(char.name == "justMoving" && position=="center"){
        removeChar.current = false;
        removeCharPosition.current = false;
        prevPosition.current="center";
        charAppearing.current=false;
        skipWaiting.current = true;
        resolve();
        return;
      }
      if(position!=="center" && !noBlur){
        if(!destinationPoint){
          changeSetting(currentBg,"current.style.filter", 1.5, "", 1.5/(Math.abs(char.initialPointX[0]-char.destinationPointX)/char.speed),false,true);
        }else if(destinationPoint){
          changeSetting(currentBg,"current.style.filter", 1.5, "", 1.5/(Math.abs(char.initialPointX[0]-destinationPoint[0])/char.speed),false,true);
        }
      }
      let screenRatio = document.body.clientWidth/document.body.clientHeight;
      if(screenRatio > 0.49 && destinationPoint && destinationPoint[2] !== undefined){
        destinationPoint[0] = destinationPoint[2];
        destinationPoint[1] = destinationPoint[3];
      }
  if(position == "center"){
    removeChar.current = false;
    removeCharPosition.current = false;
  }else{
    removeChar.current = char;
    removeCharPosition.current = position;
  }
  if(position == "left"){
    charRefLeft.current.src = emotion;
    charRefLeft.current.value = emotion;
    charRefLeft.current.style.left = char.initialPointX[0]+char.initialPointX[1];
    charRefLeft.current.style.bottom = char.initialPointY[0]+char.initialPointY[1];
    await waitCharAppearImg(position);
    if(!destinationPoint){
      await setCharParameters(charRefLeft,"current.style.transform", char.destinationPointX, char.initialPointX[1], char.speed,charRefLeft,"current.style.transform", char.destinationPointY, char.initialPointY[1], charRefLeft,"current.style.opacity", 1, "", char, position);
    }else if(destinationPoint){
      await setCharParameters(charRefLeft,"current.style.transform", destinationPoint[0], char.initialPointX[1], char.speed,charRefLeft,"current.style.transform", destinationPoint[1], char.initialPointY[1], charRefLeft,"current.style.opacity", 1, "", char, position);
    }
    prevPosition.current="left";
    if(!loading.current){
      if(!speedUp.current){
        setTimeout(f,50);
      }else{
        setTimeout(f,10);
      }
    }else{
      f();
    }
  }else if(position == "right"){
    charRefRight.current.src = emotion;
    charRefRight.current.value = emotion;
    /*if(char.rightFlip){
      charRefRight.current.style.transform = "scale(-1, 1)"
    }*/
    charRefRight.current.style.right = char.initialPointX[0]+char.initialPointX[1];
    charRefRight.current.style.bottom = char.initialPointY[0]+char.initialPointY[1];
    await waitCharAppearImg(position);
    if(!destinationPoint){
      await setCharParameters(charRefRight,"current.style.transform", char.destinationPointX, char.initialPointX[1], char.speed,charRefRight,"current.style.transform", char.destinationPointY, char.initialPointY[1], charRefRight,"current.style.opacity", 1, "", char, position, true)
    }else if(destinationPoint){
      await setCharParameters(charRefRight,"current.style.transform", destinationPoint[0], char.initialPointX[1], char.speed,charRefRight,"current.style.transform", destinationPoint[1], char.initialPointY[1], charRefRight,"current.style.opacity", 1, "", char, position, true);
    }
    prevPosition.current="right";
    if(!loading.current){
      if(!speedUp.current){
        setTimeout(f,50);
      }else{
        setTimeout(f,10);
      }
    }else{
      f();
    }
  }else if(position == "center"){
    prevPosition.current="center";
    if(!loading.current){
      if(!speedUp.current){
        setTimeout(f,Math.abs(char.initialPointX[0]-char.destinationPointX)/char.speed*10);
      }else{
        setTimeout(f,10);
      }
    }else{
      f();
    }
  }else{
    resolve();
    return;
  }
async function f(){
  if(exit.current){
    resolve();
    return;
  }
  charAppearing.current=false;
  changeSetting(particles,"current.style.opacity", 0.6, "", 0.01,false,true);
  await textAppearing(text, position, char.name, answers, timer);
  resolve();
}
});
}

async function waitCharAppearImg(position){
  if(loading.current){
    return;
  }
  return new Promise(async (resolve, reject) => {
    let loaded = false;
    while(!loaded) {
checkifPicLoaded();
await waitingFunc(16);
}
resolve();
    async function checkifPicLoaded(){
      if(exit.current){
        return;
      }
      if(position == "right"){
        if(!charRefRight.current.complete || (charRefRight.current.naturalWidth < 1) || (charRefRight.current.naturalHeight < 1)){
          return;
        }else{
          await waitingFunc(16);
          loaded=true;
          return;
        }
      }else if(position == "left"){
        if(!charRefLeft.current.complete || (charRefLeft.current.naturalWidth < 1) || (charRefLeft.current.naturalHeight < 1)){
          return;
        }else{
          await waitingFunc(16);
          loaded=true;
          return;
        }
      }
    }
});
}

async function setCharParameters(obj, setting, changeTo, um, speed, obj1, setting1, changeTo1, um1, obj2, setting2, changeTo2, um2, char, position){
  if(exit.current){
    return;
  }
  let speed1, speed2;
  return new Promise(async (resolve, reject) => {
const props = setting
    .split(/[./[\]]/g)
    .filter(p => p);
const prop = props.pop();
const parent = props.reduce((result, key) => result[key], obj);
const props1 = setting1
    .split(/[./[\]]/g)
    .filter(p => p);
const prop1 = props1.pop();
const parent1 = props1.reduce((result, key) => result[key], obj);
const props2 = setting2
    .split(/[./[\]]/g)
    .filter(p => p);
const prop2 = props2.pop();
const parent2 = props2.reduce((result, key) => result[key], obj);
if(loading.current){
  if(char && position == "left"){
    parent[prop] = "translate("+(-1)*(parseInt(char.initialPointX[0])-parseInt(changeTo))*document.body.clientWidth/100+"px, "+(parseInt(char.initialPointY[0])-parseInt(changeTo1))*document.body.clientHeight/100+"px)";
  }else if(char && position == "right"){
    parent[prop] = "translate("+(parseInt(char.initialPointX[0])-parseInt(changeTo))*document.body.clientWidth/100+"px, "+(parseInt(char.initialPointY[0])-parseInt(changeTo1))*document.body.clientHeight/100+"px)";
  }
  parent2[prop2] = changeTo2+um2;
  resolve();
  return;
}

if(position == "left"){
    changeTo=(-1)*(parseInt(char.initialPointX[0])-parseInt(changeTo));
}else if(position == "right"){
    changeTo=(parseInt(char.initialPointX[0])-parseInt(changeTo));
}
changeTo1=parseInt(char.initialPointY[0])-parseInt(changeTo1);
changeTo = changeTo*document.body.clientWidth/100;
changeTo1 = changeTo1*document.body.clientHeight/100;
um="px";
um1="px";
let pre = parent[prop];
let preI,i,preI1,i1;
if(pre !== "translate(0px)"){ //apple bug fix
preI = pre.split("translate(")[1];
i = Math.round(parseFloat(preI.split("px")[0]));
preI1 = parent1[prop1].split(", ")[1];
i1 = Math.round(preI1.split("px")[0]);
}else{
  preI = pre.split("translate(")[1];
  i = Math.round(parseFloat(preI.split("px")[0]));
  i1=0;
}
let i2 = Math.round(parent2[prop2]);
speed=speed*2.3*document.body.clientWidth/100*hzAdjuster;
speed1=(Math.abs(changeTo1 - i1)/(Math.abs(changeTo - i)/speed));
speed2=(1/(Math.abs(changeTo - i)/speed));

charAppear();
function charAppear(){
  if(exit.current){
    return;
  }
  if(speedUp.current){
    speed*=1.04;
    speed1*=1.04;
    speed2*=1.04;
  }
  if(i<changeTo){
    i+=speed;
    if(i>changeTo){
      i=changeTo;
    }
  }else if(i>changeTo){
    i-=speed;
    if(i<changeTo){
      i=changeTo;
    }
  }
  if(i1<changeTo1){
    i1+=speed1;
    if(i1>changeTo1){
      i1=changeTo1;
    }
  }else if(i1>changeTo1){
    i1-=speed1;
    if(i1<changeTo1){
      i1=changeTo1;
    }
  }
  if(i2<changeTo2){
    i2+=speed2;
    if(i2>changeTo2){
      i2=changeTo2;
    }
  }else if(i2>changeTo2){
    i2-=speed2;
    if(i2<changeTo2){
      i2=changeTo2;
    }
  }
  function animChar(){
    parent[prop] = "translate("+i+um+", "+i1+um1+")";
    parent2[prop2] = i2+um2;
    if(i !== changeTo){
      charAppear();
    }
  }
  scheduleFrameTask(animChar);
if(i == changeTo){
  resolve();
  return;
}
  return;
}
});
}

async function setTextParameters(obj, setting, changeTo, speed, changeTo1, speed1, changeTo2, speed2, setting3, changeTo3, speed3, position){
  if(exit.current){
    return;
  }
  return new Promise(async (resolve, reject) => {
const props = setting
    .split(/[./[\]]/g)
    .filter(p => p);
const prop = props.pop();
const parent = props.reduce((result, key) => result[key], obj);

const props3 = setting3
    .split(/[./[\]]/g)
    .filter(p => p);
const prop3 = props3.pop();
const parent3 = props3.reduce((result, key) => result[key], obj);

changeTo = changeTo*document.body.clientWidth/100;
changeTo1 = changeTo1*document.body.clientHeight/100;
if(loading.current){
  if(position == "left"){
    parent[prop] = "translate("+changeTo+"px, "+changeTo1+"px) scale("+changeTo2+")";
  }else if(position == "right"){
    parent[prop] = "translate("+changeTo+"px, "+changeTo1+"px) scale("+changeTo2+")";
  }else if(position == "center"){
    parent[prop] = "translate("+changeTo+"px, "+changeTo1+"px) scale("+changeTo2+")";
  }
  parent3[prop3] = changeTo3;
  resolve();
  return;
}
speed=2*1.7*document.body.clientWidth/100*hzAdjuster;
speed1=0.8*1.7*document.body.clientHeight/100*hzAdjuster;
speed2=0.04*1.7*hzAdjuster;
speed3=0.04*1.7*hzAdjuster;
let pre = parent[prop];
let preI,i,preI1,i1,preI2,i2;
if(pre !== "translate(0px) scale(1)"){ //apple bug fix
preI = pre.split("translate(")[1];
i = Math.round(parseFloat(preI.split("px")[0]));
preI1 = parent[prop].split(", ")[1];
i1 = Math.round(preI1.split("px")[0]);
preI2 = parent[prop].split("scale(")[1];
i2 = Math.round(preI2.split(")")[0]);
}else{
  preI = pre.split("translate(")[1];
  i = Math.round(parseFloat(preI.split("px")[0]));
  i1=0;
  preI2 = parent[prop].split("scale(")[1];
  i2 = Math.round(preI2.split(")")[0]);
}
let i3 = Math.round(parent3[prop3]);
textAppear();
function textAppear(){
  if(exit.current){
    return;
  }
  if(speedUp.current){
    speed*=1.04;
    speed1*=1.04;
    speed2*=1.04;
    speed3*=1.04;
  }
  if(i<changeTo){
    i+=speed;
    //i = parseFloat(i.toFixed(1));
    if(i>changeTo){
      i=changeTo;
    }
  }else if(i>changeTo){
    i-=speed;
  //  i = parseFloat(i.toFixed(1));
    if(i<changeTo){
      i=changeTo;
    }
  }
  if(i1<changeTo1){
    i1+=speed1;
    //i1 = parseFloat(i1.toFixed(1));
    if(i1>changeTo1 || (i==changeTo)){
      i1=changeTo1;
    }
  }else if(i1>changeTo1){
    i1-=speed1;
    //i1 = parseFloat(i1.toFixed(1));
    if(i1<changeTo1 || (i==changeTo)){
      i1=changeTo1;
    }
  }
  if(i2<changeTo2){
    i2+=speed2;
    //i2 = parseFloat(i2.toFixed(1));
    if(i2>changeTo2 || (i==changeTo)){
      i2=changeTo2;
    }
  }else if(i2>changeTo2){
    i2-=speed2;
  //  i2 = parseFloat(i2.toFixed(1));
    if(i2<changeTo2 || (i==changeTo)){
      i2=changeTo2;
    }
  }
  if(i3<changeTo3){
    i3+=speed3;
    //i3 = parseFloat(i3.toFixed(1));
    if(i3>changeTo3 || (i==changeTo)){
      i3=changeTo3;
    }
  }else if(i3>changeTo3){
    i3-=speed3;
    //i3 = parseFloat(i3.toFixed(1));
    if(i3<changeTo3 || (i==changeTo)){
      i3=changeTo3;
    }
  }
  function animText(){
    if(position !== "center"){
      parent[prop] = "translate("+i+"px, "+i1+"px) scale("+i2+")";
    }else{
      parent[prop] = "translate(0px, "+i1+"px) scale("+i2+")";
    }
  parent3[prop3] = i3;
  if(i !== changeTo){
  textAppear();
}
  }
  scheduleFrameTask(animText);
if(i == changeTo){
  resolve();
  speedUp.current = false;
  return;
}
  return;
}
});
}


function changeSetting(obj, setting, changeTo, um, speed, char, float, stopLoading, filter){
  if(exit.current){
    return;
  }
  speed=speed*2.3*hzAdjuster;
  if(um == "translateY"){
    speed = speed/100*document.body.clientHeight;
  }
  return new Promise((resolve, reject) => {
    const props = setting
        .split(/[./[\]]/g)
        .filter(p => p);
    const prop = props.pop();
    const parent = props.reduce((result, key) => result[key], obj);
    //
    if(loading.current && !stopLoading){
      if((setting == "current.style.transform" || setting == "style.transform") && um == "scale"){
        parent[prop] = "scale("+changeTo+")";
      }else if((setting == "current.style.transform" || setting == "style.transform") && um == "rotateY"){
        parent[prop] = "rotateY("+changeTo+"deg)";
      }else if((setting == "current.style.transform" || setting == "style.transform") && um == "translateY"){
        parent[prop] = "translateY("+changeTo+"vh)";
      }else if((setting == "current.style.filter" || setting == "style.filter")){
        if(filter == undefined){
          parent[prop] = "blur("+changeTo+"px)";
        }else{
          parent[prop] = "filter("+changeTo+um+")";
        }
      }else{
        parent[prop] = changeTo+um;
      }
      resolve();
      return;
    }
    if(um == "translateY"){
      changeTo = changeTo/100*document.body.clientHeight;
    }
    //
    var i;
    if(setting == "current.style.transform" || setting == "style.transform"){
      if(um == "translateY"){
        if(parent[prop].includes("vh")){
          i = Math.round(parseFloat(parent[prop].split("(")[1].split("vh)")[0]));
          i = i/100*document.body.clientHeight;
        }else{
          i = Math.round(parseFloat(parent[prop].split("(")[1].split("px)")[0]));
        }
      }else{
        if(float){
          i = parseFloat(parent[prop].split("(")[1].split(")")[0]);
        }else{
          i = Math.round(parseFloat(parent[prop].split("(")[1].split(")")[0]));
        }
      }
    }else if(setting == "current.style.filter" || setting == "style.filter"){
      if(filter == undefined){
        if(float){
          i = parseFloat(parent[prop].split("(")[1].split("px)")[0]);
        }else{
          i = Math.round(parseFloat(parent[prop].split("(")[1].split("px)")[0]));
        }
      }else{
        if(float){
          i = parseFloat(parent[prop].split("(")[1].split(um+")")[0]);
        }else{
          i = Math.round(parseFloat(parent[prop].split("(")[1].split(um+")")[0]));
        }
      }
    }else{
      if(float){
      i = parseFloat(parent[prop]);
      }else{
      i = Math.round(parseFloat(parent[prop]));
      }
    }
    let slowDownTrigger = 0;
    let slower = 8;
    change();
  function change(){
    if(exit.current){
      return;
    }
    if(speedUp.current){
      speed*=1.04;
    }
    if(i>changeTo){
      i-=speed;
      if(i<=changeTo){
        i = changeTo;
        if((setting == "current.style.transform" || setting == "style.transform") && um == "scale"){
          parent[prop] = "scale("+i+")";
        }else if((setting == "current.style.transform" || setting == "style.transform") && um == "rotateY"){
          parent[prop] = "rotateY("+i+"deg)";
        }else if((setting == "current.style.transform" || setting == "style.transform") && um == "translateY"){
          parent[prop] = "translateY("+i+"px)";
        }else if((setting == "current.style.filter" || setting == "style.filter")){
          if(filter == undefined){
          parent[prop] = "blur("+i+"px)";
        }else{
          parent[prop] = filter+"("+i+um+")";
        }
        }else{
          parent[prop] = i+um;
        }
        resolve();
        return;
      }
  }else if(i<changeTo){
    i+=speed;
    if(i>=changeTo){
      i = changeTo;
      if((setting == "current.style.transform" || setting == "style.transform") && um == "scale"){
        parent[prop] = "scale("+i+")";
      }else if((setting == "current.style.transform" || setting == "style.transform") && um == "rotateY"){
        parent[prop] = "rotateY("+i+"deg)";
      }else if((setting == "current.style.transform" || setting == "style.transform") && um == "translateY"){
        parent[prop] = "translateY("+i+"px)";
      }else if((setting == "current.style.filter" || setting == "style.filter")){
        if(filter == undefined){
        parent[prop] = "blur("+i+"px)";
      }else{
        parent[prop] = filter+"("+i+um+")";
      }
      }else{
        parent[prop] = i+um;
      }
      resolve();
      return;
    }
  }else{
    if((setting == "current.style.transform" || setting == "style.transform") && um == "scale"){
      parent[prop] = "scale("+i+")";
    }else if((setting == "current.style.transform" || setting == "style.transform") && um == "rotateY"){
      parent[prop] = "rotateY("+i+"deg)";
    }else if((setting == "current.style.transform" || setting == "style.transform") && um == "translateY"){
      parent[prop] = "translateY("+i+"px)";
    }else if((setting == "current.style.filter" || setting == "style.filter")){
      if(filter == undefined){
      parent[prop] = "blur("+i+"px)";
    }else{
      parent[prop] = filter+"("+i+um+")";
    }
    }else{
      parent[prop] = i+um;
    }
    resolve();
    return;
  }
  function animSet(){
    if((setting == "current.style.transform" || setting == "style.transform") && um == "scale"){
      parent[prop] = "scale("+i+")";
    }else if((setting == "current.style.transform" || setting == "style.transform") && um == "rotateY"){
      parent[prop] = "rotateY("+i+"deg)";
    }else if((setting == "current.style.transform" || setting == "style.transform") && um == "translateY"){
      parent[prop] = "translateY("+i+"px)";
    }else if((setting == "current.style.filter" || setting == "style.filter")){
      if(filter == undefined){
      parent[prop] = "blur("+i+"px)";
    }else{
      parent[prop] = filter+"("+i+um+")";
    }
    }else{
      parent[prop] = i+um;
    }
    change();
  }
  scheduleFrameTask(animSet);
return;
}
});
}


async function textAppearing(text, position, name, answers, timer){
    return new Promise(async (resolve, reject) => {
  if(exit.current){
    return;
  }
  texting.current = true;
  if(plot[numI.current+1] && plot[numI.current+1]["char"] && (name !== plot[numI.current+1]["char"]["name"]) && (position !== plot[numI.current+1]["position"])){
    if(plot[numI.current+1]["position"] == "left" && charRefLeft.current.src.split("/static/media")[1] !== plot[numI.current+1]["phrases"][0]["emotion"].split("/static/media")[1] && plot[numI.current+1]["phrases"][0]["emotion"] !== undefined){
      if((plot[numI.current-1] && plot[numI.current-1]["char"] && plot[numI.current-1]["char"]["name"] !== plot[numI.current+1]["char"]["name"] && position == "center") || (position !== "center") || ((plot[numI.current-1] == undefined || plot[numI.current-1]["char"] == undefined) && position == "center")){
        charRefLeft.current.src = plot[numI.current+1]["phrases"][0]["emotion"];
        charRefLeft.current.value = plot[numI.current+1]["phrases"][0]["emotion"];
      }
    }else if(plot[numI.current+1]["position"] == "right" && charRefRight.current.src.split("/static/media")[1] !== plot[numI.current+1]["phrases"][0]["emotion"].split("/static/media")[1] && plot[numI.current+1]["phrases"][0]["emotion"] !== undefined){
      if((plot[numI.current-1] && plot[numI.current-1]["char"] && plot[numI.current-1]["char"]["name"] !== plot[numI.current+1]["char"]["name"] && position == "center") || (position !== "center") || ((plot[numI.current-1] == undefined || plot[numI.current-1]["char"] == undefined) && position == "center")){
        charRefRight.current.src = plot[numI.current+1]["phrases"][0]["emotion"];
        charRefRight.current.value = plot[numI.current+1]["phrases"][0]["emotion"];
      }
    }
  }
  stopTexting.current = false; //resetting stopTexting var
  if(name){
    if(language == "en"){
      setCharName(name);
    }else if(language == "ru"){
      if(plot[numI.current]["char"]){
        setCharName(plot[numI.current]["char"]["nameRu"]);
      }else{
        setCharName(name);
      }
    }
  }
  //textBoxLeft.current.style.top = "0vh";
  let verticalDirection = 1;
  if(exit.current){
    return;
  }
  if(parseInt(document.getElementsByClassName("textBoxCover")[0].style.top)<40){
    verticalDirection = -1;
  }
  if(position == "left"){
    textBoxRight.current.style.display = "none";
    textBoxLeft.current.style.display = "block";
    if(answers){
      textBoxLeft.current.style.borderRadius = "1px 13px 13px 13px";
      textBoxLeftInner.current.style.borderRadius = "1px 13px 13px 13px";
    }else{
      textBoxLeft.current.style.borderRadius = "1px 13px 1px 13px";
      textBoxLeftInner.current.style.borderRadius = "1px 13px 1px 13px";
    }
      //textBoxLeft.current.style.left = "0vw";
      textBoxLeft.current.style.transform = "translate("+(-0.5)*document.body.clientWidth+"px, "+(-0.2*verticalDirection)*document.body.clientHeight+"px) scale(0)";
      if(!answers){
        await setTextParameters(textBoxLeft, "current.style.transform", 0, 2.5, 0, 1, 1, 0.05, "current.style.opacity", 1, 0.05, position);
      }else{
        await setTextParameters(textBoxLeft, "current.style.transform", 0, 2.5, -20, 1, 1, 0.05, "current.style.opacity", 1, 0.05, position);
      }
    //changeSetting(textBoxLeft,"current.style.transform", 1, "scale", 0.05);
    //changeSetting(textBoxLeft,"current.style.left", 0, "vw", 2.5);
    //if(!answers){
    //  changeSetting(textBoxLeft,"current.style.top", 0, "vh", 1);
    //}
    //await changeSetting(textBoxLeft,"current.style.opacity", 1, "", 0.05);
    prevPosition.current="left";
  }else if(position == "right"){
    textBoxLeft.current.style.display = "none";
    textBoxRight.current.style.display = "block";
    if(answers){
      textBoxRight.current.style.borderRadius = "13px 1px 13px 13px";
      textBoxRightInner.current.style.borderRadius = "13px 1px 13px 13px";
    }else{
      textBoxRight.current.style.borderRadius = "13px 1px 13px 1px";
      textBoxRightInner.current.style.borderRadius = "13px 1px 13px 1px";
    }
    //textBoxRight.current.style.right = "0vw";
    textBoxRight.current.style.transform = "translate("+(0.5)*document.body.clientWidth+"px, "+(-0.2*verticalDirection)*document.body.clientHeight+"px) scale(0)";
    //changeSetting(textBoxRight,"current.style.transform", 1, "scale", 0.05);
    //changeSetting(textBoxRight,"current.style.right", 0, "vw", 2.5);
    //if(!answers){
      //changeSetting(textBoxRight,"current.style.top", 0, "vh", 1);
    //}
    //await changeSetting(textBoxRight,"current.style.opacity", 1, "", 0.05);
    if(!answers){
      await setTextParameters(textBoxRight, "current.style.transform", 0, 2.5, 0, 1, 1, 0.05, "current.style.opacity", 1, 0.05, position);
    }else{
      await setTextParameters(textBoxRight, "current.style.transform", 0, 2.5, -20, 1, 1, 0.05, "current.style.opacity", 1, 0.05, position);
    }
    prevPosition.current="right";
  }else if(position == "center"){
    textBoxRight.current.style.display = "none";
    textBoxLeft.current.style.display = "block";
    textBoxLeft.current.style.borderRadius = "13px 13px 13px 13px";
    textBoxLeftInner.current.style.borderRadius = "13px 13px 13px 13px";

    //textBoxLeft.current.style.left = "0vw";
    textBoxLeft.current.style.transform = "translate("+(-0.5)*document.body.clientWidth+"px, "+(-0.2*verticalDirection)*document.body.clientHeight+"px) scale(0)";
    if(!answers){
      await setTextParameters(textBoxLeft, "current.style.transform", 0, 2.5, 0, 1, 1, 0.05, "current.style.opacity", 1, 0.05, position);
    }else{
      await setTextParameters(textBoxLeft, "current.style.transform", 0, 2.5, -20, 1, 1, 0.05, "current.style.opacity", 1, 0.05, position);
    }
    //changeSetting(textBoxLeft,"current.style.transform", 1, "scale", 0.05);
    //if(!answers){
    //  changeSetting(textBoxLeft,"current.style.top", 0, "vh", 1);
    //}
    //await changeSetting(textBoxLeft,"current.style.opacity", 1, "", 0.05);
    prevPosition.current="center";
  }
let i = 0;
let speed = 20; /* The speed/duration of the effect in milliseconds */
let txtHTML = "";
let open = "", close = "";
if(text.includes("<small><i>")){
  text = text.split("<small><i>")[1];
  text = text.split("</small></i>")[0];
  open = "<small><i>";
  close = "</small></i>";
}
await typeWriter();
if(answers){
  if(loading.current){
    fff();
  }else{
    setTimeout(fff,200);
  }
}else{
  resolve();
}
async function fff(){
  if(exit.current){
    return;
  }
  await answersAppearing(answers);
  resolve();
}
//
async function typeWriter() {
  if(exit.current){
    return;
  }
  return new Promise(async (resolve, reject) => {
    if(loading.current){
      stopTexting.current = true;
    }
  if(text.length>5){
    if(i===6){ //setting skipbutton
      skipButton.current = true;
    }
  }else{
    skipButton.current = true;
  }

  if (i < text.length) {
    txtHTML += text.charAt(i);
    if(text.charAt(i+1)){
      txtHTML += text.charAt(i+1);
    }
    if(position === "left" || position === "center"){
      setTextBoxLeftText("<p>"+open+txtHTML+close+"</p>");
    }else if(position === "right"){
      setTextBoxRightText("<p>"+open+txtHTML+close+"</p>");
    }
    i+=2;
    if(stopTexting.current == false){
      if(i>=text.length){
        await waitingFunc(100);
        texting.current = false;
        skipButton.current = false;
        resolve();
         return;
      }
     setTimeout(awaitTypeWriter, speed);
     async function awaitTypeWriter(){
       await typeWriter();
       resolve();
       return;
     }
  }else if(stopTexting.current == true){
    if(position === "left" || position === "center"){
      setTextBoxLeftText("<p>"+open+text+close+"</p>");
    }else if(position === "right"){
      setTextBoxRightText("<p>"+open+text+close+"</p>");
    }
      await waitingFunc(100);
      texting.current = false;
      skipButton.current = false;
      resolve();
      return;
    }
  }
});
}
});
}

async function textDisappearing(){
  if(exit.current){
    return;
  }
  document.getElementById("wrap").onclick = speedUpGame;
  let verticalDirection = 1;
  if(exit.current){
    return;
  }
  if(parseInt(document.getElementsByClassName("textBoxCover")[0].style.top)<40){
    verticalDirection = -1;
  }
  if(prevPosition.current == "left"){
    //changeSetting(textBoxLeft,"current.style.transform", 0, "scale", 0.05);
    //changeSetting(textBoxLeft,"current.style.left", -50, "vw", 2.5);
    //changeSetting(textBoxLeft,"current.style.top", -20, "vh", 1);
    //await changeSetting(textBoxLeft,"current.style.opacity", 0, "", 0.05);
    await setTextParameters(textBoxLeft, "current.style.transform", -50, 2.5, -20*verticalDirection, 1, 0, 0.05, "current.style.opacity", 0, 0.05, prevPosition.current);
    setTextBoxLeftText("");
    await waitingFunc(100);
  }else if(prevPosition.current == "right"){
    //changeSetting(textBoxRight,"current.style.transform", 0, "scale", 0.05);
    //changeSetting(textBoxRight,"current.style.right", -50, "vw", 2.5);
    //changeSetting(textBoxRight,"current.style.top", -20, "vh", 1);
    //await changeSetting(textBoxRight,"current.style.opacity", 0, "", 0.05);
    await setTextParameters(textBoxRight, "current.style.transform", 50, 2.5, -20*verticalDirection, 1, 0, 0.05, "current.style.opacity", 1, 0.05, prevPosition.current);
    setTextBoxRightText("");
    await waitingFunc(100);
  }
  else if(prevPosition.current == "center"){
    //changeSetting(textBoxLeft,"current.style.transform", 0, "scale", 0.05);
    //changeSetting(textBoxLeft,"current.style.top", -20, "vh", 1);
    //await changeSetting(textBoxLeft,"current.style.opacity", 0, "", 0.05);
    //document.getElementById("textBoxLeft").innerHTML = "";
    await setTextParameters(textBoxLeft, "current.style.transform", -50, 2.5, -20*verticalDirection, 1, 0, 0.05, "current.style.opacity", 0, 0.05, prevPosition.current);
    setTextBoxLeftText("");
    await waitingFunc(100);
  }
  return;
}
 function answersDisappearing(answer){
   if(exit.current){
     return;
   }
   if(answer>3){
     answer=0;
   }
  return new Promise(async (resolve, reject) => {
    if(timerOn.current){
      timerOn.current = false;
      await changeSetting(timerText,"current.style.opacity", 0, "", 0.02);
      timerText.current.style.display = "none";
    }
  if(answersBox.current.style.display === "flex"){
    if(warningShown.current){
      achievementDisappear();
      warningShown.current = false;
    }
    await changeSetting(eval("answerBox"+answer),"current.style.opacity", 0, "", 0.03);
    let arr =  [0,1,2,3];
    arr.splice(answer, 1);
    for(let key in arr){
      let v = Math.floor(Math.random() * ((arr.length-1) - 0 + 1) + 0);
      await changeSetting(eval("answerBox"+arr[v]),"current.style.opacity", 0, "", 0.03);
      arr.splice(v, 1);
    }
  answersBox.current.style.display = "none";
  if(loading.current){
    resolve();
  }else{
    setTimeout(f,200);
  }


  function f(){
    resolve();
  }
}else{
  resolve();
}
});
}
async function answersAppearing(answers){
  return new Promise(async (resolve, reject) => {
  if(exit.current){
    return;
  }
  let oneBoxHeight = 45;
  if(document.body.clientWidth >= 375 && document.body.clientHeight >= 730){
    oneBoxHeight = 60;
  }
  answersBox.current.style.height = oneBoxHeight*answers.length+"px";
  answersBox.current.style.display = "flex";
  let ansNum;
  for(let key in answers){
    eval("answerBox"+parseInt(key)).current.style.display = "flex";
    eval("answerBox"+parseInt(key)).current.style.transform = "scale(0)";
    eval("answerBox"+parseInt(key)).current.innerHTML = answers[key];
    ansNum = parseInt(key);
  }
  for(ansNum+=1;ansNum<4;ansNum++){
    eval("answerBox"+parseInt(ansNum)).current.style.display = "none";
  }
  for(let key in answers){
    changeSetting(eval("answerBox"+parseInt(key)),"current.style.opacity", 1, "", 0.03);
    await changeSetting(eval("answerBox"+parseInt(key)),"current.style.transform", 1, "scale", 0.03);
  }
  resolve();
});
}

async function answerHandler(e, startI, startJ, timeOutValue){
  if(answering.current){
  answering.current=false;
  await answer();
  }
    function answer(){
      if(exit.current){
        return;
      }
          return new Promise(async (resolve, reject) => {
            if(loading.current){
              if(answered.current){
                prevAnswered.current.push(answered.current);
              }
              console.log(savedAnswers.current[answerNum.current][1]);
              if(savedAnswers.current[answerNum.current][1] == "4"){
                answered.current = "Skip";
              }else{
                let currentAnswers = document.getElementsByClassName("answerVN");
                for(let k = 0; k < currentAnswers.length; k++){
                  if(savedAnswers.current[answerNum.current][1] == currentAnswers[k].getAttribute('name')){
                    answered.current = currentAnswers[k].innerHTML;
                    break;
                  }
                }
              }

            }else{
              if(timeOutValue){
                savedAnswers.current.push([timeOutValue[0], timeOutValue[1]]);
              }else{
                if(phoebeUncomfortableCondition.current && e.target.innerHTML == phoebeUncomfortableCondition.current[1] && phoebesComfort.current < phoebeUncomfortableCondition.current[0]){
                  savedAnswers.current.push(phoebeUncomfortableCondition.current[2]);
                }else{
                  savedAnswers.current.push([e.target.innerHTML, e.target.getAttribute('name')]);
                }
              }
              if(answered.current){
                prevAnswered.current.push(answered.current);
              }
              if(timeOutValue){
                answered.current = timeOutValue[0];
              }else{
                if(phoebeUncomfortableCondition.current && e.target.innerHTML == phoebeUncomfortableCondition.current[1] && phoebesComfort.current < phoebeUncomfortableCondition.current[0]){
                  answered.current = phoebeUncomfortableCondition.current[2][0];
                }else{
                answered.current = e.target.innerHTML;
              }
              }
            }
            if(phoebeUncomfortableCondition.current){
              phoebeUncomfortableCondition.current = false;
            }
              if(arrowBackVisible.current){
                clearTimeout(arrowBackVisible.current);
                backMenuDisappear();
              }
              if(loading.current){
                if(timeOutValue){
                  await answersDisappearing(0);
                }else{
                  await answersDisappearing(savedAnswers.current[answerNum.current][1],);
                }
              }else{
                if(timeOutValue){
                  await answersDisappearing(0);
                }else{
                  await answersDisappearing(e.target.getAttribute('name'));
                }
              }
              await textDisappearing();
              wrap.current.style.zIndex = 10;
              if(loading.current){
                gameStart(startI+1, 0, true);
              }else{
                gameStart(numI.current+1, numJ.current);
              }
              answerNum.current++;
              resolve();
            });
          }
}


async function gameStart(nI, nJ, load){
  if(exit.current){
    return;
  }
  if(load){
    loading.current = true;
  }
  let answers, rightOption = false;
for(let i = nI; i<plot.length; i++){
	if(plot[i+1] && plot[i+1].endOfGame){
    document.getElementById("backWrapVNId").style.zIndex = 0;
  }
	if(plot[i].endOfNovel){
    if(plot[i].musicContinue){
      musicContinueSwitch(true);
    }
    nextNovel(plot[i].endOfChapter);
    return;
  }
  if(!loading.current){
  numI.current = i;
  setSave(previous => previous + 1)
  }
  if(answered.current){
    if(plot[i].endOfOptions){
      if(prevAnswered.current.length>0){
        answered.current = prevAnswered.current[prevAnswered.current.length-1];
        prevAnswered.current.splice(prevAnswered.current.length-1, 1);
        rightOption = true;
      }else{
        if(!plot[i].subEnd){
          answered.current = false;
        }
        rightOption = false;
      }
      continue;
    }
  }
   if(answered.current && !rightOption){
    if((plot[i].option === answered.current) && plot[i].start){
      rightOption = true;
      continue;
    }else{
      continue;
    }
  }else if(answered.current && rightOption){
    if((plot[i].option === answered.current) && plot[i].endOfOption){
        rightOption = false;
      continue;
    }
  }

  if(plot[i].changeBG){
    await changeBG(plot[i].img, plot[i].smooth, plot[i].sizeChange);
    if(plot[i]["gallery"] !== undefined && gallerySC.current[plot[i]["gallery"][2]][1] == "0"){
        gallerySC.current[plot[i]["gallery"][2]][1] = "1";
        setSaveGallerySC(previous => previous + 1);
    }
    continue;
  }

  if((plot[i].phoebesComfort || plot[i].achievementCondition) && !loading.current){

    if(plot[i].phoebesComfort){
    if(plot[i].set){
      phoebesComfort.current = plot[i].set;
    }else if(plot[i].plus){
      phoebesComfort.current += plot[i].plus;
    }
    setSavePhoebesComfort(previous => previous + 1);
    }

    if(plot[i].achievementCondition){
    if(plot[i].achievementConditionSet){
      achievementCondition.current = plot[i].achievementConditionSet;
    }
    setSaveAchievementCondition(previous => previous + 1);
    }

    continue;
  }

  if(plot[i].char){
    let iCheck;
    if(i==0){
      iCheck = 0;
    }else{
      iCheck = i-1;
      if(plot[iCheck]["changeBG"] && plot[iCheck-1]["endOfSceneLoadNext"]){
        iCheck = i-2;
      }
    }
    if(plot[i].dialogCoordinates){
      document.getElementsByClassName("textBoxCover")[0].style.top = plot[i].dialogCoordinates;
    }
    if(plot[i].overScene){
      charRefRight.current.style.zIndex = 8;
      charRefRightUnder.current.style.zIndex = 7;
      charRefLeft.current.style.zIndex = 8;
      charRefLeftUnder.current.style.zIndex = 7;
    }
    if((answered.current && rightOption) || !answered.current){
      let prevCharName;
      if(prevChar.current.char){
        prevCharName = prevChar.current.char.name;
      }
    for(let j = nJ;j<plot[i]["phrases"].length; j++){
        if(!loading.current){
        numJ.current = j;
        setSave(previous => previous + 1);
      }
      await musicHandler(plot[i]["phrases"][j],i,j);
      if(plot[i]["phrases"][j]["item"] !== undefined){
        if(plot[i]["phrases"][j]["open"]){
          await openItem(plot[i]["phrases"][j]["item"]);
          await loadingEnd(i,j);
          await waitin();
          continue;
        }else if(plot[i]["phrases"][j]["close"]){
          itemFloating.current = false;
          while(item.current.style.display !== "none"){
            await waitingFunc(50, true);
          }
          continue;
        }
      }
      if(j===0 && !plot[iCheck]["endOfScene"] && (prevChar.current.coordinates !== plot[i].coordinates)){
        //may need to vary speed depend on the path
        await moveBgTo(plot[i]["coordinates"], plot[i]["speed"], plot[i]["char"], plot[i]["phrases"][j]["emotion"], plot[i]["position"], plot[i]["phrases"][j]["text"], plot[i]["phrases"][j]["answers"], plot[i]["phrases"][j]["timer"], plot[i]["noBlur"], plot[i]["destinationPoint"], plot[i]["appearAfterMoving"], plot[i]["changeBGTransition"], plot[i]["transitionMode"], true);
        if(plot[i]["position"] !== "center" && plot[i]["phrases"][j]["animation"]){
        animateEmotion(plot[i]["position"], plot[i]["phrases"][j]["emotion"], plot[i]["char"])
        }
      }else if(j == 0 && (prevChar.current.coordinates == plot[i].coordinates) && i !== 0  && (prevCharName !== plot[i]["char"].name) && (prevChar.current.position !== "center")){
        if(plot[i]["position"] !== "center" && plot[i]["keepPrev"] == undefined){
          await disappearing(removeChar.current, removeCharPosition.current, plot[i]["destinationPoint"]);
          if(plot[i]["fadeBgNon"]){
            await changeSetting(fade,"current.style.opacity", 0, "", 0.004, false, true);
            fade.current.style.display = "none";
            if(plot[i]["position"] == "left"){
              charRefLeft.current.style.zIndex = 4;
              charRefLeftUnder.current.style.zIndex = 3;
            }else if(plot[i]["position"] == "right"){
              charRefRight.current.style.zIndex = 4;
              charRefRightUnder.current.style.zIndex = 3;
            }
          }
          if(plot[i]["keepPrevEnd"]){
              removeCharPosition.current = plot[i]["position"];
          }
          await appearing(plot[i]["char"], plot[i]["phrases"][j]["emotion"], removeCharPosition.current, plot[i]["phrases"][j]["text"], plot[i]["phrases"][j]["answers"], plot[i]["phrases"][j]["timer"], plot[i]["noBlur"], plot[i]["destinationPoint"]);
        }else if(plot[i]["position"] !== "center" && plot[i]["keepPrev"] == true){
          if(plot[i]["fadeBg"]){
            if(plot[i]["position"] == "left"){
              charRefLeft.current.style.zIndex = 7;
              charRefLeftUnder.current.style.zIndex = 6;
            }else if(plot[i]["position"] == "right"){
              charRefRight.current.style.zIndex = 7;
              charRefRightUnder.current.style.zIndex = 6;
            }
            fade.current.style.display = "block";
            await changeSetting(fade,"current.style.opacity", 0.35, "", 0.005, false, true);
          }
          await appearing(plot[i]["char"], plot[i]["phrases"][j]["emotion"], plot[i]["position"], plot[i]["phrases"][j]["text"], plot[i]["phrases"][j]["answers"], plot[i]["phrases"][j]["timer"], plot[i]["noBlur"], plot[i]["destinationPoint"]);
        }else{
        await textAppearing(plot[i]["phrases"][j]["text"], plot[i]["position"], plot[i]["char"]["name"], plot[i]["phrases"][j]["answers"], plot[i]["phrases"][j]["timer"]);
        }
        if(plot[i]["position"] !== "center" && plot[i]["phrases"][j]["animation"]){
        animateEmotion(plot[i]["position"], plot[i]["phrases"][j]["emotion"], plot[i]["char"])
        }
      }else if(plot[iCheck]["endOfSceneLoadNext"] && j == 0){
        if(loading.current){
          await moveBgTo(plot[i]["coordinates"], plot[i]["speed"], plot[i]["char"], plot[i]["phrases"][j]["emotion"], plot[i]["position"], plot[i]["phrases"][j]["text"], plot[i]["phrases"][j]["answers"], plot[i]["phrases"][j]["timer"], plot[i]["noBlur"], plot[i]["destinationPoint"], plot[i]["appearAfterMoving"], plot[i]["changeBGTransition"], plot[i]["transitionMode"], true);
          await textDisappearing();
          if(plot[i]["position"] !== "center" && plot[i]["phrases"][j]["animation"]){
          animateEmotion(plot[i]["position"], plot[i]["phrases"][j]["emotion"], plot[i]["char"])
          }
        }else if(!loading.current){
          loading.current = true;
          await moveBgTo(plot[i]["coordinates"], plot[i]["speed"], plot[i]["char"], plot[i]["phrases"][j]["emotion"], plot[i]["position"], plot[i]["phrases"][j]["text"], plot[i]["phrases"][j]["answers"], plot[i]["phrases"][j]["timer"], plot[i]["noBlur"], plot[i]["destinationPoint"], plot[i]["appearAfterMoving"], plot[i]["changeBGTransition"], plot[i]["transitionMode"], true);
          await textDisappearing();
          if(plot[i]["position"] !== "center" && plot[i]["phrases"][j]["animation"]){
          animateEmotion(plot[i]["position"], plot[i]["phrases"][j]["emotion"], plot[i]["char"])
          }
          loading.current = false;
        }
        await waitingFunc(plot[iCheck].time);
        if(!loading.current){
          await changeSetting(wrap,"current.style.opacity", 0, "", 0.01);
        }
        await textAppearing(plot[i]["phrases"][j]["text"], plot[i]["position"], plot[i]["char"]["name"], plot[i]["phrases"][j]["answers"], plot[i]["phrases"][j]["timer"]);
      }else{
        if(plot[i]["position"] !== "center"){
        changeEmotion(plot[i]["position"], plot[i]["phrases"][j]["emotion"], plot[i]["char"], plot[i]["phrases"][j]["animation"]);
        }
        await textAppearing(plot[i]["phrases"][j]["text"], plot[i]["position"], plot[i]["char"]["name"], plot[i]["phrases"][j]["answers"], plot[i]["phrases"][j]["timer"]);
      }
      if(plot[i]["phrases"][j]["soundEffect"]){
        if(plot[i]["phrases"][j]["soundEffectVolume"]){
          setVolumeEffects(plot[i]["phrases"][j]["soundEffectVolume"]);
        }else{
          setVolumeEffects(1);
        }
        if(!loading.current){
          while(isPlayingEffects){
            await waitingFunc(60);
          }
        playEffects(plot[i]["phrases"][j]["soundEffect"], false);
      }else{
        if(i == numI.current && j == numJ.current){
          soundEffect.current = plot[i]["phrases"][j]["soundEffect"];
        }
      }
      }
      if(!plot[i]["phrases"][j]["answers"] && plot[i]["phrases"][j]["note"] !== undefined && (!loading.current || (numJ.current == j && numI.current == i))){
          achievementAppear(["🫥", plot[i]["phrases"][j]["note"], "❗", 0], true, true);
      }
      if(plot[i]["phrases"][j]["answers"]){
        if(plot[i]["phrases"][j]["warning"] !== undefined && (!loading.current || (numJ.current == j && numI.current == i))){
            achievementAppear(["🦋", plot[i]["phrases"][j]["warning"], "❗", 0], true);
            warningShown.current = true;
        }
        wrap.current.style.zIndex = 8;
        answering.current = true;
        prevChar.current = plot[i];
        await loadingEnd(i,j);
        if(plot[i]["phrases"][j]["timer"] && !loading.current){
          timerOn.current = true;
          timerText.current.style.display = "block";
          await changeSetting(timerText,"current.style.opacity", 1, "", 0.02);
          startTimer(plot[i]["phrases"][j]["timer"], "Text", ["Skip", "4"]);
        }
        if(!loading.current){
          numJ.current = 0;
        }
        return;
      }
      if(plot[i]["phrases"][j]["setNextStep"]){
        nextStep.current = plot[i]["phrases"][j]["setNextStep"];
      }
      if(plot[i]["phrases"][j]["achievement"] !== undefined && achievementsSave.current[plot[i]["phrases"][j]["achievement"][3]][2] == 0){
        if(plot[i]["phrases"][j]["achievementConditionValue"]){
          if(plot[i]["phrases"][j]["achievementConditionValue"][0] == achievementCondition.current){
            achievementsSave.current[plot[i]["phrases"][j]["achievement"][3]][2] = 1;
            setSaveAchievements(previous => previous + 1);
            achievementAppear(plot[i]["phrases"][j]["achievement"]);
          }
        }else{
          achievementsSave.current[plot[i]["phrases"][j]["achievement"][3]][2] = 1;
          setSaveAchievements(previous => previous + 1);
          achievementAppear(plot[i]["phrases"][j]["achievement"]);
        }
      }
      if(plot[i]["phrases"][j]["gallery"] !== undefined && gallerySC.current[plot[i]["phrases"][j]["gallery"][2]][1] == "0"){
          gallerySC.current[plot[i]["phrases"][j]["gallery"][2]][1] = "1";
          setSaveGallerySC(previous => previous + 1);
      }
      if(plot[i]["phrases"][j]["vibration"] && !loading.current){
        try{
          navigator.vibrate(0);
          navigator.vibrate(plot[i]["phrases"][j]["vibration"]);
      }catch(e){
        console.log(e);
      }
      }
      await loadingEnd(i,j);
      if(skipWaiting.current !== true){
        await waitin();
        await textDisappearing();
      }else{
        skipWaiting.current = false;
      }
      if(plot[i]["phrases"][j]["lastTry"]){
        let gameStep = step + plot[i]["phrases"][j]["setNextStep"];
        if(state.current[gameStep]["tryNum"]<plot[i]["phrases"][j]["lastTry"]){
          break;
        }
      }
    }
  }
  prevChar.current = plot[i];

}else if(plot[i].scene){
  if(exit.current){
    return;
  }
  if(plot[i].dialogCoordinates){
    document.getElementsByClassName("textBoxCover")[0].style.top = plot[i].dialogCoordinates;
  }
  if(plot[i]["gallery"] !== undefined && gallerySC.current[plot[i]["gallery"][2]][1] == "0"){
      gallerySC.current[plot[i]["gallery"][2]][1] = "1";
      setSaveGallerySC(previous => previous + 1);
  }
  if(plot[i].changeScene){
  await changeScene(plot[i].img, plot[i].slowMode, plot[i].syncPrev);
  await loadingEnd(i);
  }
  if(plot[i].blackScreen){
    if(plot[i].startBS){
      blackScreenRef.current.style.display = "block";
      await changeSetting(blackScreenRef,"current.style.opacity", 1, "", 0.01);
    }else if(plot[i].endBS){
      await changeSetting(blackScreenRef,"current.style.opacity", 0, "", 0.01);
      blackScreenRef.current.style.display = "none";
    }
    if(plot[i].wait){
      await waitingFunc(plot[i].wait);
    }
}
  if(plot[i].start){
    await sceneStart(plot[i].img, plot[i].time, plot[i].img2, plot[i].actionEvent, plot[i].skip);
    await loadingEnd(i);
    await musicHandler(plot[i],i,undefined);
    if(!plot[i].skipFirstTap){
      await waitin();
    }
  }else if(plot[i].phrases){
    if((answered.current && rightOption) || !answered.current){
    for(let j = nJ;j<plot[i]["phrases"].length; j++){
        if(!loading.current){
      numJ.current = j;
      setSave(previous => previous + 1);
        }

  await textAppearing(plot[i]["phrases"][j]["text"],plot[i]["position"], plot[i]["name"], plot[i]["phrases"][j]["answers"], plot[i]["phrases"][j]["timer"]);
  await musicHandler(plot[i]["phrases"][j],i,j);
  if(!plot[i]["phrases"][j]["answers"] && plot[i]["phrases"][j]["note"] !== undefined && (!loading.current || (numJ.current == j && numI.current == i))){
      achievementAppear(["🫥", plot[i]["phrases"][j]["note"], "❗", 0], true, true);
  }
  if(plot[i]["phrases"][j]["answers"]){
    wrap.current.style.zIndex = 8;
    answering.current = true;
    prevChar.current = plot[i];
    await loadingEnd(i,j);
    if(plot[i]["phrases"][j]["timer"] && !loading.current){
      timerOn.current = true;
      timerText.current.style.display = "block";
      await changeSetting(timerText,"current.style.opacity", 1, "", 0.02);
      startTimer(plot[i]["phrases"][j]["timer"], "Text", ["Skip", "4"]);
    }
    if(plot[i]["phrases"][j]["phoebeUncomfortableCondition"] && !loading.current){
      phoebeUncomfortableCondition.current = plot[i]["phrases"][j]["phoebeUncomfortableCondition"];
    }
    if(!loading.current){
      numJ.current = 0;
    }
    return;
  }
  if(plot[i]["phrases"][j]["achievement"] !== undefined && achievementsSave.current[plot[i]["phrases"][j]["achievement"][3]][2] == 0){
    if(plot[i]["phrases"][j]["achievementConditionValue"]){
      if(plot[i]["phrases"][j]["achievementConditionValue"][0] == achievementCondition.current){
        achievementsSave.current[plot[i]["phrases"][j]["achievement"][3]][2] = 1;
        setSaveAchievements(previous => previous + 1);
        achievementAppear(plot[i]["phrases"][j]["achievement"]);
      }
    }else{
      achievementsSave.current[plot[i]["phrases"][j]["achievement"][3]][2] = 1;
      setSaveAchievements(previous => previous + 1);
      achievementAppear(plot[i]["phrases"][j]["achievement"]);
    }
  }
  await loadingEnd(i,j);
  if(plot[i]["phrases"][j]["autoPlay"]){
  autoPlayDialog.current = plot[i]["phrases"][j]["autoPlay"];
  }
  let skipWaiting=false;
  if(plot[i]["phrases"][j]["actionStart"] && !loading.current){
     if(plot[i]["phrases"][j]["actionStart"][0] == "Hold"){
      skipWaiting=true;
      holdProgress=0;
      //if(sceneRefVid.current.style.display !== "none"){
        //changeSetting(sceneRefVid,"current.style.filter", 0.5, "", 0.005, false,true, false, "saturate");
      //}
      actionSound.current = plot[i]["phrases"][j]["actionStart"][6];
      if(sceneRef.current.style.display !== "none"){
        changeSetting(sceneRef,"current.style.filter", 0.5, "", 0.005, false,true, false, "saturate");
      }
      holdButtonComplete.current = false;
      holdButtonActive.current = true;
      actionButtons.current.style.opacity = "0";
      actionButtons.current.style.display = "block";
      holdButtonRef.current.style.display = "flex";
      holdButtonRef.current.style.opacity="1";
      timerAction.current.style.marginTop = `5px`;
      if(plot[i]["phrases"][j]["actionStart"][1]){
        actionButtons.current.style.left = plot[i]["phrases"][j]["actionStart"][1][0];
        actionButtons.current.style.top = plot[i]["phrases"][j]["actionStart"][1][1];
      }
      if(plot[i]["phrases"][j]["actionStart"][5]){
        timerAction.current.style.display = "block";
      }
      await waitingFunc(300);
      await changeSetting(actionButtons,"current.style.opacity", 1, "", 0.01);
      if(plot[i]["phrases"][j]["actionStart"][5]){
        timerActionOn.current = true;
        timerSet.current = true;
        startActionTimer(plot[i]["phrases"][j]["actionStart"][5], plot[i]["phrases"][j]["actionStart"][0]);
      }else{
        timerSet.current = false;
      }
      if(!loading.current){
        await holdWaiter();
      }
    }
    if(plot[i]["phrases"][j]["actionStart"][0] == "Slider"){
      if(exit.current){
        return;
      }
     skipWaiting=true;
    sliderButtonComplete.current = false;

    actionSound.current = plot[i]["phrases"][j]["actionStart"][6];
    if(plot[i]["phrases"][j]["actionStart"][4] == "hard"){
      sliderDifficulty.current = 0.02;
    }else if(plot[i]["phrases"][j]["actionStart"][4] == "medium"){
      sliderDifficulty.current = 0.03;
    }else{
      sliderDifficulty.current = 0.05;
    }
     directionSlider.current = plot[i]["phrases"][j]["actionStart"][2];
     if(directionSlider.current === "up"){
sliderButtonRefCircleRef.current.style.transform = "rotate(270deg)";
}else if(directionSlider.current === "down"){
  sliderButtonRefCircleRef.current.style.transform = "rotate(90deg)";
}else if(directionSlider.current === "left"){
  sliderButtonRefCircleRef.current.style.transform = "rotate(180deg)";
}else if(directionSlider.current === "right"){
  sliderButtonRefCircleRef.current.style.transform = "rotate(0deg)";
}
if(plot[i]["phrases"][j]["actionStart"][3]){
  pathLength.current = plot[i]["phrases"][j]["actionStart"][3];
}
     actionButtons.current.style.opacity = "0";
     actionButtons.current.style.display = "block";
     sliderButtonRef.current.style.opacity="1";
     sliderButtonRef.current.style.display = "block";
     if(plot[i]["phrases"][j]["actionStart"][1]){
       actionButtons.current.style.left = plot[i]["phrases"][j]["actionStart"][1][0];
       actionButtons.current.style.top = plot[i]["phrases"][j]["actionStart"][1][1];
     }
     if(plot[i]["phrases"][j]["actionStart"][5]){
       timerAction.current.style.display = "block";
       if(directionSlider.current === "down"){
         timerAction.current.style.marginTop = `calc( -15vw - 10px )`;
       }else{
         timerAction.current.style.marginTop = `5px`;
       }
     }
     await waitingFunc(300);
     await changeSetting(actionButtons,"current.style.opacity", 1, "", 0.01);
     if(plot[i]["phrases"][j]["actionStart"][5]){
       timerActionOn.current = true;
       startActionTimer(plot[i]["phrases"][j]["actionStart"][5], plot[i]["phrases"][j]["actionStart"][0]);
     }
     if(!loading.current){
       await sliderWaiter();
     }
   }
  }
  if(plot[i]["phrases"][j]["vibration"] && !loading.current){
    try{
      navigator.vibrate(0);
      navigator.vibrate(plot[i]["phrases"][j]["vibration"]);
  }catch(e){
    console.log(e);
  }
  }
  if(plot[i]["phrases"][j]["vibrationCancel"] && !loading.current){
    try{
      navigator.vibrate(0);
  }catch(e){
    console.log(e);
  }
  }
  if(!skipWaiting && !autoPlayDialog.current){
    await waitin();
  }
  if(autoPlayDialog.current && !skipWaiting){
    await waitingFunc(autoPlayDialog.current);
  }

  await textDisappearing();
  if(plot[i]["phrases"][j]["actionStart"]){
    if(plot[i]["phrases"][j]["actionStart"][0] == "Tap"){
      actionButtons.current.style.opacity = "0";
      actionButtons.current.style.display = "block";
      tapButtonRef.current.style.display = "block";
      await waitingFunc(300);
      await changeSetting(actionButtons,"current.style.opacity", 1, "", 0.01);
      if(!loading.current){
        await tapProgressReducer();
      }
    }
  }
}

}
}else if(plot[i].endOfScene && !plot[i]["endOfSceneLoadNext"]){
    await musicHandler(plot[i],i,undefined);
    await sceneEnd(plot[i].time, plot[i].skip);
  }else if(plot[i]["endOfSceneLoadNext"]){
      await musicHandler(plot[i],i,undefined);
      await sceneEndLoadNext(plot[i].time);
  }
}else if(plot[i].controls){
  await loadingEnd(i);
  if(plot[i].setTime){
    vidProgress.current.value = plot[i].setTime;
    let secTotal = vidProgress.current.value/100*1523;
    let min = Math.round(secTotal / 60);
    let sec = Math.round(secTotal % 60);
    if(min<10){
      min = "0"+min;
    }
    if(sec<10){
      sec = "0"+sec;
    }
    vidTime.current.innerHTML = min+":"+sec+"/25:23";
  }
  if(plot[i].pause){
    let preloadActive = false;
    if(plot[i].preLoad && !loading.current){
      loading.current = true;
      preloadActive = true;
      setIsPlayingVid(false);
    }
    vid.current.style.display = "block";
    changeSetting(vidBottom,"current.style.transform", 0, "translateY", 0.12, false, true);
    await waitingFunc(50);
    await changeSetting(vidTop,"current.style.transform", 0, "translateY", 0.12, false, true);
    await changeSetting(vidButton,"current.style.opacity", 1, "", 0.01);
      await waitingFunc(150);
    setIsPlayingVid(false);
    if(currentBg.current.src.includes(".mp4")){
      currentBg.current.pause();
      pausedAfterLoad.current = true;
    }
    await waitingFunc(500);
    if(plot[i].preLoad && preloadActive){
      loading.current = false;
      await waitingFunc(300);
    }
  }else if(plot[i].play){
    if(currentBg.current.src.includes(".mp4")){
      currentBg.current.play();
      pausedAfterLoad.current = false;
    }
    setIsPlayingVid(true);
    await waitingFunc(300);
    changeSetting(vidTop,"current.style.transform", -7, "translateY", 0.15, false, true);
    await waitingFunc(100);
    changeSetting(vidBottom,"current.style.transform", 8, "translateY", 0.15, false, true);
    await changeSetting(vidButton,"current.style.opacity", 0, "", 0.01);
    await waitingFunc(300);
    vid.current.style.display = "none";
  }
}
}
}

async function musicHandler(currentStep,i,j){
  return new Promise(async (resolve, reject) => {
    if(musicContinue){
        if(currentStep["musicStart"]){
          transitionVolume(currentStep["musicSettings"][0],currentStep["musicSettings"][1]);
        }
        if(currentStep["ambientStart"]){
          transitionVolumeAmbient(currentStep["ambientSettings"][0],currentStep["ambientSettings"][1]);
       }
        musicContinueSwitch(false);
      resolve();
      return;
    }
  if(currentStep["musicStart"]){
    if(!loading.current){
    setVolume(0);
    if(currentStep["startPoint"]){
    playMusic(currentStep["musicStart"], currentStep["loopTime"], currentStep["startPoint"]);
    }else{
      playMusic(currentStep["musicStart"], currentStep["loopTime"]);
    }
    if(currentStep["musicSettings"]){
      transitionVolume(currentStep["musicSettings"][0],currentStep["musicSettings"][1]);
    }else{
      transitionVolume(0.8,1200);
    }
  }else{
    startMusic.current = [currentStep["musicStart"], currentStep["loopTime"], currentStep["musicSettings"], currentStep["startPoint"]];
  }
  }
  if(currentStep["musicChangeSettings"]){
    if(!loading.current){
      transitionVolume(currentStep["musicChangeSettings"][0],currentStep["musicChangeSettings"][1]);
  }else{
    if(startMusic.current){
      startMusic.current[2] = currentStep["musicChangeSettings"];
    }
  }
  }
  if(currentStep["musicChangeSpeed"]){
    if(!loading.current){
      transitionSpeed(currentStep["musicChangeSpeed"][0],currentStep["musicChangeSpeed"][1]);
  }else{
    if(startMusic.current){
      startMusic.current[4] = currentStep["musicChangeSpeed"][0];
    }
  }
  }
  if(currentStep["musicEnd"]){
    if(!loading.current){
    if(currentStep["musicSettings"] && currentStep["wait"]){
      await transitionVolume(0,currentStep["musicSettings"]);
      stopMusic();
    }else if(currentStep["musicSettings"]){
      transitionVolume(0,currentStep["musicSettings"]);
      setTimeout(stopMusic,currentStep["musicSettings"]+50);
    }else if(currentStep["wait"]){
      await transitionVolume(0,1200);
      stopMusic();
    }else{
      transitionVolume(0,1200);
      setTimeout(stopMusic,1250);
    }
  }else{
    startMusic.current = false;
  }
  }
  if(currentStep["soundEffectPre"]){
    if(currentStep["soundEffectVolume"]){
      setVolumeEffects(currentStep["soundEffectVolume"]);
    }else{
      setVolumeEffects(1);
    }
    if(!loading.current){
      while(isPlayingEffects){
        await waitingFunc(60);
      }
      playEffects(currentStep["soundEffectPre"], false);
  }else{
    if(i == numI.current && j == numJ.current){
      soundEffect.current = currentStep["soundEffectPre"];
    }
  }
  }
  if(currentStep["soundEffectEnd"]){
    if(currentStep["effectSettings"]){
      transitionVolumeEffects(0, currentStep["effectSettings"]);
      setTimeout(stopEffects,currentStep["effectSettings"]+50);
    }else{
      transitionVolumeEffects(0, 300);
      setTimeout(stopEffects,350);
    }
  }
  if(currentStep["ambientStart"]){
    if(!loading.current){
    setVolumeAmbient(0);
    if(currentStep["startPointAmbient"]){
      playAmbient(currentStep["ambientStart"], currentStep["loopTimeAmbient"], currentStep["startPointAmbient"]);
    }else{
      playAmbient(currentStep["ambientStart"], currentStep["loopTimeAmbient"]);
    }
    if(currentStep["ambientSettings"]){
      transitionVolumeAmbient(currentStep["ambientSettings"][0],currentStep["ambientSettings"][1]);
    }else{
      transitionVolumeAmbient(0.8,1200);
    }
  }else{
    startAmbient.current = [currentStep["ambientStart"], currentStep["loopTimeAmbient"], currentStep["ambientSettings"], currentStep["startPointAmbient"]];
  }
  }
  if(currentStep["ambientChangeSettings"]){
    if(!loading.current){
      transitionVolumeAmbient(currentStep["ambientChangeSettings"][0],currentStep["ambientChangeSettings"][1]);
  }else{
    if(startAmbient.current){
      startAmbient.current[2] = currentStep["ambientChangeSettings"];
    }
  }
  }
  if(currentStep["ambientChangeSpeed"]){
    if(!loading.current){
      transitionSpeedAmbient(currentStep["ambientChangeSpeed"][0],currentStep["ambientChangeSpeed"][1]);
  }else{
    if(startAmbient.current){
      startAmbient.current[4] = currentStep["ambientChangeSpeed"][0];
    }
  }
  }
  if(currentStep["ambientEnd"]){
    if(!loading.current){
    if(currentStep["ambientSettings"] && currentStep["wait"]){
      await transitionVolumeAmbient(0,currentStep["ambientSettings"]);
      stopAmbient();
    }else if(currentStep["ambientSettings"]){
      transitionVolumeAmbient(0,currentStep["ambientSettings"]);
      setTimeout(stopAmbient,currentStep["ambientSettings"]+50);
    }else if(currentStep["wait"]){
      await transitionVolumeAmbient(0,1200);
      stopAmbient();
    }else{
      transitionVolumeAmbient(0,1200);
      setTimeout(stopAmbient,1250);
    }
  }else{
    startAmbient.current = false;
  }
  }
  resolve();
});
}

function loadingEnd(i,j){ //check if game's loading
  if(exit.current){
    return;
  }
  return new Promise(async (resolve, reject) => {
  if((loading.current && i == numI.current && j == numJ.current) || (loading.current && i == numI.current && j == undefined)){
      setTimeout(awaitLoadingEnd,100);
      async function awaitLoadingEnd(){
        if(bgRef.current.src && !cachedImgs.current.has(bgRef.current.src)){
          await new Promise((resolve, reject) => {
              const img = new Image();
              img.onload = () => {
                cachedImgs.current.set(bgRef.current.src, img);
                resolve(img);
              };
              img.onerror = () => {
                reject(new Error('Failed to load ' + bgRef.current.src));
              };
              img.src = bgRef.current.src;
              if (img.complete) {
                cachedImgs.current.set(bgRef.current.src, img);
                resolve(img);
              }
            });
        }
        if(sceneRef.current.style.backgroundImage && sceneRef.current.style.display == "block"){
          let urlScene = sceneRef.current.style.backgroundImage.split('url("')[1].split('")')[0];
          if(!cachedImgs.current.has(urlScene)){
            await new Promise((resolve, reject) => {
                const img = new Image();
                img.onload = () => {
                  cachedImgs.current.set(urlScene, img);
                  resolve(img);
                };
                img.onerror = () => {
                  reject(new Error('Failed to load ' + urlScene));
                };
                img.src = urlScene;
                if (img.complete) {
                  cachedImgs.current.set(urlScene, img);
                  resolve(img);
                }
              });
          }
        }
        if(bgRefVid.current.style.display == "block" && !pausedAfterLoad.current){
          bgRefVid.current.play();
        }
        if(sceneRefVid.current.style.display == "block"){
          sceneRefVid.current.play();
        }
        loading.current = false;
        if(startMusic.current){
          setVolume(0);
          if(startMusic.current[3]){
            playMusic(startMusic.current[0], startMusic.current[1], startMusic.current[3]);
          }else{
            playMusic(startMusic.current[0], startMusic.current[1]);
          }
          if(startMusic.current[4]){
              audio.playbackRate = startMusic.current[4];
          }else{
              audio.playbackRate = 1;
          }
          if(startMusic.current[2]){
            transitionVolume(startMusic.current[2][0],startMusic.current[2][1]);
          }else{
            transitionVolume(0.8,1200);
          }
        }
        if(startAmbient.current){
          setVolumeAmbient(0);
          if(startAmbient.current[3]){
          playAmbient(startAmbient.current[0], startAmbient.current[1], startAmbient.current[3]);
          }else{
          playAmbient(startAmbient.current[0], startAmbient.current[1]);
          }
          if(startAmbient.current[4]){
              ambient.playbackRate = startAmbient.current[4];
          }else{
              ambient.playbackRate = 1;
          }
          if(startAmbient.current[2]){
            transitionVolumeAmbient(startAmbient.current[2][0],startAmbient.current[2][1]);
          }else{
            transitionVolumeAmbient(0.8,1200);
          }
        }
        if(soundEffect.current){
          while(isPlayingEffects){
            await waitingFunc(60);
          }
          playEffects(soundEffect.current, false);
        }
        resolve();
        return;
      }
}else if(loading.current && answering.current){
    answerHandler(undefined, i, j);
    resolve();
    return;
}else{
  resolve();
  return;
}
});
}

async function openItem(img){
  if(exit.current){
    return;
  }
  item.current.src = img;
  item.current.style.display = "block";
  if(!loading.current){
    await waitSceneActionImg(item);
    await waitingFunc(200);
  }
  changeSetting(item,"current.style.transform", 1, "scale", 0.033, false, true);
  changeSetting(item,"current.style.top", 20, "vh", 0.66, false, true);
  await changeSetting(item,"current.style.right", 10, "vw", 3, false, true);
  itemFloat();
  itemFloating.current = true;
}
async function itemFloat(){
  if(exit.current){
    return;
  }
  await changeSetting(item,"current.style.top", 19.8, "vh", 0.005, false, true);
  if(!itemFloating.current){
    closeItem();
  }
  await changeSetting(item,"current.style.top", 20.2, "vh", 0.005, false, true);
  if(itemFloating.current){
    if(loading.current){
      setTimeout(itemFloat, 16);
    }else{
      setTimeout(itemFloat, 300);
    }
}else{
  await closeItem();
}
}
async function closeItem(){
  if(exit.current){
    return;
  }
  changeSetting(item,"current.style.transform", 0, "scale", 0.033, false, true);
  changeSetting(item,"current.style.top", 0, "vh", 0.66, false, true);
  await changeSetting(item,"current.style.right", 100, "vw", 3, false, true);
  item.current.style.display = "none";
}

async function sceneStart(img, apTime, img2, actionEvent, skip){
  if(exit.current){
    return;
  }
    if(loading.current){
      if(actionEvent){
        bgTappingRef.current.src = img;
        bgTappingRef.current.style.display = "block";
        if(window.innerWidth/window.innerHeight <= 0.5625){
          let lowing = 1280/bgTappingRef.current.clientHeight;
          sceneBGPositionZero = (720/lowing - window.innerWidth)/2 *-1;
          bgTappingRef.current.style.transform = "translate("+sceneBGPositionZero+"px, 0)";
          bgTappingRef.current.style.filter = "brightness(0.9)";
        }else{
          sceneBGPositionZero=0;
          let lowing = 1280/bgTappingRef.current.clientHeight;
          let heightIncrease = window.innerWidth/(720/lowing);
          let heightPx = bgTappingRef.current.clientHeight*heightIncrease+"px";
          bgTappingRef.current.style.height = heightPx;
          bgTappingRef.current.style.filter = "brightness(0.9)";
        }
      }else{
        if(img.includes(".mp4")){
          sceneRefVid.current.style.display = "block";
          sceneRefVid.current.style.opacity = 1;
          sceneRefVid.current.src = img;
          await waitVideoReady(sceneRefVid.current, true);
          if(sceneRefVid.current.clientWidth-document.body.clientWidth>0){
            sceneRefVid.current.style.height = "100vh";
            sceneRefVid.current.style.width = "auto";
            sceneRefVid.current.style.transform = "translate("+(-1*(sceneRefVid.current.clientWidth-document.body.clientWidth)/2)+"px, 0)";
          }else{
            sceneRefVid.current.style.width = "100vw";
            sceneRefVid.current.style.height = "auto";
            sceneRefVid.current.style.transform = "translate(0, "+(-1*(sceneRefVid.current.clientHeight-document.body.clientHeight)/2)+"px)";
          }
        }else{
          sceneRefVid.current.style.display = "none";
          sceneRefVidUnder.current.style.display = "none";
        sceneRef.current.style.display = "block";
        sceneRef.current.style.opacity = 1;
        sceneRef.current.style.backgroundImage = "url("+img+")";
        if(img2){
          sceneRefBG.current.style.display = "block";
          sceneRefBG.current.style.backgroundImage = "url("+img2+")";
        }
      }
      }
      return;
    }
  return new Promise(async (resolve, reject) => {
    if(!skip){
      await changeSetting(wrap,"current.style.opacity", 1, "", 0.01);
    }
  if(actionEvent){
    bgTappingRef.current.style.display = "block";
    bgTappingRef.current.src = img;
    if(window.innerWidth/window.innerHeight <= 0.5625){
      let lowing = 1920/bgTappingRef.current.clientHeight;
      sceneBGPositionZero = (1080/lowing - window.innerWidth)/2 *-1;
      bgTappingRef.current.style.transform = "translate("+sceneBGPositionZero+"px, 0)";
    }else{
      sceneBGPositionZero=0;
      let lowing = 1920/bgTappingRef.current.clientHeight;
      let heightIncrease = window.innerWidth/(1080/lowing);
      let heightPx = bgTappingRef.current.clientHeight*heightIncrease+"px";
      bgTappingRef.current.style.height = heightPx;
    }
    await waitSceneActionImg(bgTappingRef);
  }else{
    if(img.includes(".mp4")){
      sceneRefVid.current.style.display = "block";
      sceneRefVid.current.style.opacity = 1;
      sceneRefVid.current.src = img;
      await waitVideoReady(sceneRefVid.current, true);
      if(sceneRefVid.current.clientWidth-document.body.clientWidth>0){
        sceneRefVid.current.style.height = "100vh";
        sceneRefVid.current.style.width = "auto";
        sceneRefVid.current.style.transform = "translate("+(-1*(sceneRefVid.current.clientWidth-document.body.clientWidth)/2)+"px, 0)";
      }else{
        sceneRefVid.current.style.width = "100vw";
        sceneRefVid.current.style.height = "auto";
        sceneRefVid.current.style.transform = "translate(0, "+(-1*(sceneRefVid.current.clientHeight-document.body.clientHeight)/2)+"px)";
      }
      sceneRefVid.current.play();
    }else{
      sceneRefVid.current.style.display = "none";
      sceneRefVidUnder.current.style.display = "none";
      sceneRef.current.style.display = "block";
      sceneRef.current.style.opacity = 1;
      sceneRef.current.style.backgroundImage = "url("+img+")";
      await waitSceneImg(sceneRef.current.style.backgroundImage, img);
      if(img2){
        sceneRefBG.current.style.display = "block";
        sceneRefBG.current.style.backgroundImage = "url("+img2+")";
        await waitSceneImg(sceneRefBG.current.style.backgroundImage, img2);
      }
    }
  }



    await waitingFunc(apTime);
    await changeSetting(wrap,"current.style.opacity", 0, "", 0.01);
    resolve();
});
}

async function changeScene(img, slowMode, syncPrev){
  if(exit.current){
    return;
  }
  return new Promise(async (resolve, reject) => {
  if(loading.current){
    if(img.includes(".mp4")){
      if(sceneRef.current.style.display == "block"){
        sceneRef.current.style.display="none";
      }
      sceneRefVid.current.style.display="block";
      sceneRefVid.current.src = img;
      await waitVideoReady(sceneRefVid.current, true);
      if(sceneRefVid.current.clientWidth-document.body.clientWidth>0){
        sceneRefVid.current.style.height = "100vh";
        sceneRefVid.current.style.width = "auto";
        sceneRefVid.current.style.transform = "translate("+(-1*(sceneRefVid.current.clientWidth-document.body.clientWidth)/2)+"px, 0)";
      }else{
        sceneRefVid.current.style.width = "100vw";
        sceneRefVid.current.style.height = "auto";
        sceneRefVid.current.style.transform = "translate(0, "+(-1*(sceneRefVid.current.clientHeight-document.body.clientHeight)/2)+"px)";
      }
    }else{
      sceneRefVid.current.style.display="none";
      sceneRef.current.style.display="block";
      sceneRef.current.style.backgroundImage = "url("+img+")";
    }
    resolve();
    return;
  }
    if(img.includes(".mp4")){
      if(sceneRef.current.style.display == "block"){
        sceneRef.current.style.zIndex = 6;
      }
      sceneRefVidUnder.current.style.display = "block";
      sceneRefVidUnder.current.src = img;
      await waitVideoReady(sceneRefVidUnder.current, true);
      if(sceneRefVidUnder.current.clientWidth-document.body.clientWidth>0){
        sceneRefVidUnder.current.style.height = "100vh";
        sceneRefVidUnder.current.style.width = "auto";
        sceneRefVidUnder.current.style.transform = "translate("+(-1*(sceneRefVidUnder.current.clientWidth-document.body.clientWidth)/2)+"px, 0)";
      }else{
        sceneRefVidUnder.current.style.width = "100vw";
        sceneRefVidUnder.current.style.height = "auto";
        sceneRefVidUnder.current.style.transform = "translate(0, "+(-1*(sceneRefVidUnder.current.clientHeight-document.body.clientHeight)/2)+"px)";
      }
      sceneRefVidUnder.current.play();
      if(syncPrev){
        await syncVideo(sceneRefVid.current, sceneRefVidUnder.current);
      }
      if(sceneRefVid.current.style.display == "block"){
        if(slowMode){
          await changeSetting(sceneRefVid,"current.style.opacity", 0, "", 0.012, false, true);
        }else{
          await changeSetting(sceneRefVid,"current.style.opacity", 0, "", 0.02, false, true);
        }
      }else if(sceneRef.current.style.display == "block"){
        if(slowMode){
          await changeSetting(sceneRef,"current.style.opacity", 0, "", 0.012, false, true);
        }else{
          await changeSetting(sceneRef,"current.style.opacity", 0, "", 0.02, false, true);
        }
        sceneRef.current.style.zIndex = 5;
        sceneRefVid.current.style.opacity = "0";
        sceneRef.current.style.display = "none";
      }
      sceneRefVid.current.style.display = "block";
      sceneRefVid.current.src = img;
      await waitVideoReady(sceneRefVid.current, true);
      sceneRefVid.current.style.width = sceneRefVidUnder.current.style.width;
      sceneRefVid.current.style.height = sceneRefVidUnder.current.style.height;
      sceneRefVid.current.style.transform = sceneRefVidUnder.current.style.transform;
      sceneRefVid.current.play();
      await syncVideo(sceneRefVidUnder.current, sceneRefVid.current);
      if(sceneRefUnder.current.style.opacity == 1){
        await changeSetting(sceneRefVid,"current.style.opacity", 0, "", 0.02);
      }else{
        await changeSetting(sceneRefVid,"current.style.opacity", 1, "", 0.02);
      }
      sceneRefVidUnder.current.style.display = "none";
    }else{
  sceneRefUnder.current.style.display = "block";
  sceneRefUnder.current.style.opacity = "1";
  sceneRefUnder.current.style.backgroundImage = "url("+img+")";
  await waitSceneImg(sceneRefUnder.current.style.backgroundImage, img);
  let opacitySpeed;
  if(img.includes("gif") || img.includes("webp")){
    opacitySpeed = 0.01;
  }else{
    opacitySpeed = 0.02;
  }
  if(sceneRef.current.style.display == "block"){
    if(slowMode){
      await changeSetting(sceneRef,"current.style.opacity", 0, "", 0.012);
    }else{
      await changeSetting(sceneRef,"current.style.opacity", 0, "", 0.02);
    }
  }else if(sceneRefVid.current.style.display == "block"){
    if(slowMode){
      await changeSetting(sceneRefVid,"current.style.opacity", 0, "", 0.012);
    }else{
      await changeSetting(sceneRefVid,"current.style.opacity", 0, "", 0.02);
    }
  }
  sceneRef.current.style.display = "block";
  sceneRef.current.style.backgroundImage = "url("+img+")";
  sceneRef.current.style.opacity = 1;
  sceneRefUnder.current.style.display = "none";
  sceneRefUnder.current.style.backgroundImage = "none";
  sceneRefUnder.current.style.opacity = 0;
  }
  resolve();
  return;
});
}

async function waitSceneImg(sceneDiv, img){
  return new Promise(async (resolve, reject) => {
    let loaded = false;
    while(!loaded) {
checkifPicLoaded();
await waitingFunc(16);
}
resolve();
    async function checkifPicLoaded(){
      if(exit.current){
        return;
      }
      if(sceneDiv !== undefined){
      sceneDiv = sceneDiv.split('url("')[1].split('")')[0];
    }
        if(sceneDiv !== img){
          return;
        }else{
          await waitingFunc(16);
          loaded=true;
          return;
        }
      }
});
}

async function waitSceneActionImg(sceneDiv){
  return new Promise(async (resolve, reject) => {
    let loaded = false;
    while(!loaded) {
checkifPicLoaded();
await waitingFunc(16);
}
resolve();
    async function checkifPicLoaded(){
      if(exit.current){
        return;
      }
        if(!sceneDiv.current.complete || (sceneDiv.current.naturalWidth < 1) || (sceneDiv.current.naturalHeight < 1)){
          return;
        }else{
          await waitingFunc(16);
          loaded=true;
          return;
        }
      }
});
}

async function sceneEnd(disapTime, skip){
  if(exit.current){
    return;
  }
  if(loading.current){
    sceneRef.current.style.display = "none";
    sceneRefVid.current.style.display = "none";
    if(sceneRefBG.current.style.display == "block"){
      sceneRefBG.current.style.display = "none";
    }
    bgTappingRef.current.style.display = "none";
    bgTappingRef.current.src = "";
    return;
  }
  return new Promise(async (resolve, reject) => {
  await changeSetting(wrap,"current.style.opacity", 1, "", 0.01);
  sceneRef.current.style.display = "none";
  sceneRefVid.current.style.display = "none";
  if(sceneRefBG.current.style.display == "block"){
    sceneRefBG.current.style.display = "none";
  }
  bgTappingRef.current.style.display = "none";
  bgTappingRef.current.src = "";
  await waitingFunc(disapTime);
  if(!skip){
    await changeSetting(wrap,"current.style.opacity", 0, "", 0.01);
  }
  resolve();
});
}

async function sceneEndLoadNext(disapTime){
  if(exit.current){
    return;
  }
  if(loading.current){
    sceneRef.current.style.display = "none";
    sceneRefVid.current.style.display = "none";
    if(sceneRefBG.current.style.display == "block"){
      sceneRefBG.current.style.display = "none";
    }
    return;
  }
  return new Promise(async (resolve, reject) => {
  await changeSetting(wrap,"current.style.opacity", 1, "", 0.01);
  sceneRef.current.style.display = "none";
  sceneRefVid.current.style.display = "none";
  if(sceneRefBG.current.style.display == "block"){
    sceneRefBG.current.style.display = "none";
  }
  resolve();
});
}

function waitVideoReady(video, stopLoad) {
  if (!(video instanceof HTMLVideoElement)) return Promise.reject(new TypeError('video required'));
  const HAVE_ENOUGH = HTMLMediaElement.HAVE_ENOUGH_DATA;
  if (video.readyState >= HAVE_ENOUGH) return Promise.resolve();
  return new Promise(async (resolve, reject) => {
    let loaded = false;
    while(!loaded) {
checkifPicLoaded();
await waitingFunc(8, stopLoad);
}
resolve();
function checkifPicLoaded(){
  if (video.readyState >= HAVE_ENOUGH) {
    loaded=true;
  }
}
  });
}

function syncVideo(v1, v2, { tolerance = 0.05} = {}) {
  return new Promise((resolve, reject) => {
    const masterTime = v1.currentTime || 0;

    function onSeeked() {
      v2.removeEventListener('seeked', onSeeked);

      if (Math.abs(v1.currentTime - v2.currentTime) <= tolerance) {
        Promise.all([v1.play().catch(e => e), v2.play().catch(e => e)])
          .then(results => {
            const bothFailed = results.every(r => r instanceof Error);
            if (bothFailed) {
              reject();
            } else {
              resolve();
            }
          })
          .catch(e => {
            reject();
          });
      } else {
        v2.currentTime = v1.currentTime;
        v2.addEventListener('seeked', onSeeked, { once: true });
      }
    }
    v2.pause();
    v2.addEventListener('seeked', onSeeked, { once: true });
    try {
      v2.currentTime = masterTime;
    } catch (e) {
      reject();
    }
  });
}

async function changeBG(img, smooth, sizeChange){
  if(exit.current){
    return;
  }
  return new Promise(async (resolve, reject) => {
      if(img.includes(".mp4")){
        bgRefVidUnder.current.style.display = "block";
        bgRefVidUnder.current.src = img;
        await waitVideoReady(bgRefVidUnder.current, true);
        if(!loading.current || sizeChange){
          bgRefVidUnder.current.play();
        }
        bgRefVidUnder.current.style.bottom = currentBg.current.style.bottom;
        if(sizeChange){
          bgRefVidUnder.current.style.left = currentBg.current.clientWidth-bgRefVidUnder.current.clientWidth+"px";
          bgRefVidUnder.current.style.transform = currentBg.current.style.transform;
        }else{
          bgRefVidUnder.current.style.left = currentBg.current.style.left;
          bgRefVidUnder.current.style.transform = currentBg.current.style.transform;
        }
        await changeSetting(currentBg,"current.style.opacity", 0, "", 0.02, false, true);
        currentBg.current.style.display = "none";
        currentBg.current = bgRefVid.current;
        currentBg.current.style.opacity = 0;
        currentBg.current.style.display = "block";
        currentBg.current.src = img;
        currentBg.current.value = img;
        await waitVideoReady(currentBg.current, true);
        if(!loading.current){
          bgRefVid.current.play();
          await syncVideo(bgRefVidUnder.current, currentBg.current);
        }
        currentBg.current.style.bottom = bgRefVidUnder.current.style.bottom;
        currentBg.current.style.left = bgRefVidUnder.current.style.left
        currentBg.current.style.transform = bgRefVidUnder.current.style.transform;
        await changeSetting(currentBg,"current.style.opacity", 1, "", 0.01, false, true);
        bgRefVidUnder.current.style.display = "none";
      }else{
      if(smooth){
    bgRefUnder.current.style.display = "block";
    bgRefUnder.current.src = img;
    bgRefUnder.current.style.bottom = currentBg.current.style.bottom;
    await waitBGUnderImg(false, true);
    if(sizeChange){
      bgRefUnder.current.style.left = currentBg.current.clientWidth-bgRefUnder.current.clientWidth+"px";
      bgRefUnder.current.style.transform = currentBg.current.style.transform;
    }else{
      bgRefUnder.current.style.left = currentBg.current.style.left;
      bgRefUnder.current.style.transform = currentBg.current.style.transform;
    }
    await changeSetting(currentBg,"current.style.opacity", 0, "", 0.02, false, true);
    currentBg.current.style.display = "none";
    currentBg.current = bgRef.current;
    currentBg.current.style.display = "block";
    currentBg.current.style.left = bgRefUnder.current.style.left;
    currentBg.current.style.transform = bgRefUnder.current.style.transform;
    if(img.includes("gif") || img.includes("webp")){
      currentBg.current.src = "";
      if(!loading.current){
        await waitingFunc(50);
      }
      currentBg.current.src = img;
      currentBg.current.value = img;
      if(!loading.current){
      await waitBGImg();
      }
      await changeSetting(currentBg,"current.style.opacity", 1, "", 0.01, false, true);
      bgRefUnder.current.style.display = "none";
      bgRefUnder.current.src = "";
    }else{
      currentBg.current.src = img;
      currentBg.current.value = img;
      if(sizeChange){
        currentBg.current.style.left = bgRefUnder.current.style.left;
      }
      currentBg.current.style.opacity = 1;
      bgRefUnder.current.style.display = "none";
      bgRefUnder.current.src = "";
    }
  }else{
    if(currentBg.current.src.includes(".mp4")){
      bgRef.current.src = img;
      bgRef.current.style.display = "block";
      currentBg.current.display = "none";
      currentBg.current = bgRef.current;
    }else{
      bgRef.current.src = img;
      bgRef.current.value = img;
    }
  }
}
  resolve();
});
}

async function changeEmotion(position, emotion, char, anim){
  if(exit.current){
    return;
  }
    return new Promise(async (resolve, reject) => {
  if(position == "left"){
    if(charRefLeft.current.value == emotion){
      resolve();
      return;
    }
    animation.current = true;
    charRefLeftUnder.current.style.display = "block";
    charRefLeftUnder.current.src = emotion;
    charRefLeftUnder.current.style.bottom = charRefLeft.current.style.bottom;
    charRefLeftUnder.current.style.left = charRefLeft.current.style.left;
    charRefLeftUnder.current.style.transform = charRefLeft.current.style.transform;
    await waitCharImg(position, emotion);
    await changeSetting(charRefLeft,"current.style.opacity", 0, "", 0.05, false, true);
    charRefLeft.current.src = emotion;
    charRefLeft.current.value = emotion;
    charRefLeft.current.style.opacity = 1;
    charRefLeftUnder.current.style.display = "none";
    charRefLeftUnder.current.src = "";
  }else if(position =="right"){
    if(charRefRight.current.value == emotion){
      return;
    }
    animation.current = true;
    charRefRightUnder.current.style.display = "block";
    charRefRightUnder.current.src = emotion;
    charRefRightUnder.current.style.bottom = charRefRight.current.style.bottom;
    charRefRightUnder.current.style.right = charRefRight.current.style.right;
    charRefRightUnder.current.style.transform = charRefRight.current.style.transform;
    await waitCharImg(position, emotion);
    await changeSetting(charRefRight,"current.style.opacity", 0, "", 0.05,false, true);
    charRefRight.current.src = emotion;
    charRefRight.current.value = emotion;
    charRefRight.current.style.opacity = 1;
    charRefRightUnder.current.style.display = "none";
    charRefRightUnder.current.src = "";
  }

  async function waitCharImg(){
    if(loading.current){
      return;
    }
    return new Promise(async (resolve, reject) => {
      let loaded = false;
      while(!loaded) {
  checkifPicLoaded();
  await waitingFunc(16);
}
resolve();
      async function checkifPicLoaded(){
        if(exit.current){
          return;
        }
        if(position == "right"){
          if(!charRefRightUnder.current.complete || (charRefRightUnder.current.naturalWidth < 1) || (charRefRightUnder.current.naturalHeight < 1)){
            return;
          }else{
            await waitingFunc(16);
            loaded=true;
            return;
          }
        }else if(position == "left"){
          if(!charRefLeftUnder.current.complete || (charRefLeftUnder.current.naturalWidth < 1) || (charRefLeftUnder.current.naturalHeight < 1)){
            return;
          }else{
            await waitingFunc(16);
            loaded=true;
            return;
          }
        }
      }
  });
  }

  if(anim){
await animateEmotion(position, emotion, char);
}else{
  animation.current = false;
}
resolve();
return;
});
}

async function animateEmotion(position, emotion, char){
  if(exit.current){
    return;
  }
    return new Promise(async (resolve, reject) => {
  animation.current = true;
  if(position == "left"){
    var varToChange = charRefLeft;
    var positionToChange = "current.style.left";
  }else if(position == "right"){
    var varToChange = charRefRight;
    var positionToChange = "current.style.right";
  }

//laughing
if(emotion.includes("laughing")){
let dest = parseInt(char.destinationPointY)+1;
await changeSetting(varToChange,"current.style.bottom", dest, "vh", 0.05);
await changeSetting(varToChange,"current.style.bottom", char.destinationPointY, "vh", 0.1);
await changeSetting(varToChange,"current.style.bottom", dest, "vh", 0.05);
await changeSetting(varToChange,"current.style.bottom", char.destinationPointY, "vh", 0.1);
await changeSetting(varToChange,"current.style.bottom", dest, "vh", 0.05);
await changeSetting(varToChange,"current.style.bottom", char.destinationPointY, "vh", 0.1);
await changeSetting(varToChange,"current.style.bottom", dest, "vh", 0.05);
await changeSetting(varToChange,"current.style.bottom", char.destinationPointY, "vh", 0.1);

//angry
}else if(emotion.includes("angry")){
let dest0 = parseInt(char.destinationPointX);
let dest1 = parseInt(char.destinationPointX)+0.5;
let dest2 = parseInt(char.destinationPointX)-0.5;
await changeSetting(varToChange,positionToChange, dest1, "vw", 0.1);
await changeSetting(varToChange,positionToChange, dest2, "vw", 0.1);
await changeSetting(varToChange,positionToChange, dest1, "vw", 0.1);
await changeSetting(varToChange,positionToChange, dest2, "vw", 0.1);
await changeSetting(varToChange,positionToChange, dest1, "vw", 0.1);
await changeSetting(varToChange,positionToChange, dest2, "vw", 0.1);
await changeSetting(varToChange,positionToChange, dest1, "vw", 0.1);
await changeSetting(varToChange,positionToChange, dest2, "vw", 0.1);
await changeSetting(varToChange,positionToChange, dest0, "vw", 0.1);
}
animation.current = false;
resolve();
});
}

async function backMenuAppear(hint){
  if(exit.current){
    return;
  }
  if(!arrowBackVisible.current && backMenuCheck.current == false){
    backMenuCheck.current = true;
    arrowBack.current.style.display = "block";
    await changeSetting(arrowBack,"current.style.opacity", 1, "", 0.03);
    if(hint == "firstTime"){
      await changeSetting(arrowBack,"current.style.transform", 1.2, "scale", 0.01, false, true);
      await changeSetting(arrowBack,"current.style.transform", 1, "scale", 0.01, false, true);
      await changeSetting(arrowBack,"current.style.transform", 1.2, "scale", 0.01, false, true);
      await changeSetting(arrowBack,"current.style.transform", 1, "scale", 0.01, false, true);
    }
    arrowBackVisible.current = true;
    arrowBackVisible.current = setTimeout(() => {
  backMenuDisappear();
}, 7000);
  }
}

async function backMenuDisappear(){
  if(exit.current){
    return;
  }
  if(arrowBackVisible.current && backMenuCheck.current == true){
  backMenuCheck.current = false;
  await changeSetting(arrowBack,"current.style.opacity", 0, "", 0.01);
  arrowBack.current.style.display = "none";
  arrowBackVisible.current = false;
}
}

async function achievementAppear(achievementUnlock, warning, closeWarning){
  if(exit.current){
    return;
  }
  let text;
  if(warning){
    text = achievementUnlock[1];
    document.getElementsByClassName('achievementEmoji')[0].innerHTML = achievementUnlock[2];
  }else{
    stopEffectsVN();
    setVolumeEffectsVN(0.7);
    playEffectsVN(achievementSound, false);
    if(language == "en"){
      text = 'Achievement unlocked!<br/>"' + achievementUnlock[1] +'"';
    }else if(language == "ru"){
      text = 'Достижение разблокировано!<br/>"' + achievementsRu[achievementUnlock[3]] +'"';
    }
    document.getElementsByClassName('achievementEmoji')[0].innerHTML = "🏆";
  }
  achievementUnlock[2] = 1;
  achievement.current.style.display = "flex";
  let h = achievement.current.getElementsByClassName("cup")[0].querySelectorAll("h4")[0].clientHeight+6;
  achievement.current.getElementsByClassName("cup")[0].querySelectorAll("h4")[0].style.marginTop = (45-h)/2+"px";
  achievement.current.getElementsByClassName("cup")[0].querySelectorAll("h4")[0].style.marginLeft = "1px";
  await changeSetting(achievement,"current.style.transform", 1, "scale", 0.03);
  achievement.current.querySelectorAll("p")[0].innerHTML = text;
  let w = achievement.current.querySelectorAll("p")[0].clientWidth;
  await width();
  achievement.current.querySelectorAll("p")[0].style.opacity = "1";
  achievement.current.querySelectorAll("p")[0].innerHTML = '';
  var txtHTML = "", i = 0;
  await changeSetting(achievement.current.getElementsByClassName("cup")[0],"style.transform", 90, "rotateY", 3);
  achievement.current.getElementsByClassName("cup")[0].querySelectorAll("h4")[0].innerHTML = achievementUnlock[0];
   changeSetting(achievement.current.getElementsByClassName("cup")[0],"style.transform", 0, "rotateY", 3);
  setTimeout(typeWriter, 50);
  if(!warning || closeWarning){
  setTimeout(achievementDisappear, 3000);
}else{
  return;
}


  async function width(){
    if(exit.current){
      return;
    }
    return new Promise(async (resolve, reject) => {
      setTimeout(fu,300);
        async function fu(){
          if(exit.current){
            return;
          }
  await changeSetting(achievement,"current.style.width", (w+60+20), "px", 4);
  resolve();
}
});
}

  async function typeWriter() {
    if(exit.current){
      return;
    }
    return new Promise((resolve, reject) => {
    if (i < text.length) {
      txtHTML += text.charAt(i);
      if(text.charAt(i+1)){
        txtHTML += text.charAt(i+1);
      }
      achievement.current.querySelectorAll("p")[0].innerHTML = txtHTML;
      i+=2;
        if(i>=text.length-1){
          resolve();
        }
       setTimeout(awaitTypeWriter, 11.2);
       async function awaitTypeWriter(){
         if(exit.current){
           return;
         }
         await typeWriter();
         resolve();
       }
    }
  });
}
}

async function achievementDisappear(){
  if(exit.current){
    return;
  }
  changeSetting(achievement.current.querySelectorAll("p")[0],'style.opacity', 0, "", 0.06);
  await changeSetting(achievement,"current.style.width", 50, "px", 4);
  await waitingFunc(300);
  await changeSetting(achievement,"current.style.transform", 0, "scale", 0.03);
  achievement.current.style.display = "none";
}

  return (
<div className='wrap'>
<div className="container1" style={{display:"none", opacity:"0", left:"60vw", top:"50vh"}} ref={actionButtons}>
<div className="buttonСontainerSlide" style={{display:"none", opacity:"1"}} ref={sliderButtonRef}>
       <div className="button1" id="slideButton" >
       <div className="circle" ref={sliderButtonRefCircleRef}>
       <div className="arrow">
        <span></span>
        <span></span>
        <span></span>
    </div>
        </div>
        </div>
        </div>
        <div className="buttonСontainerTap" style={{display:"none", opacity:"1"}} ref={tapButtonRef}>
  <span className='pulseButton'>{textTranslation[language]["tap"]}</span>
        </div>
        <div className="buttonСontainerHold" style={{display:"none", opacity:"1"}} ref={holdButtonRef}>
  <span className='holdButton'>{textTranslation[language]["hold"]}</span>
        </div>
        <div className="status-bar" ref={timerAction} style={{opacity:"1", display:"none", marginTop:`5px`}}><div className="progress" id="progressAction"></div></div>
   </div>
<div className='achievement' ref={achievement} style={{transform: "scale(0)", display:"none", width:"50px"}}>
<p className='achievementText' style={{opacity:"0"}}></p>
<div className='cup' style={{transform: "rotateY(0deg)"}}>
  <h4 className='achievementEmoji'>🏆</h4>
  </div>
</div>
<div className="controlsWrap" ref={vid} style={{display:"none"}}>
<div className="topLineVid" ref={vidTop} style={{transform:"translateY(-7vh)"}}>
<div className="arrowBack" style={{ transform:"scaleY(0.9) scaleX(0.8) rotate(180deg)", opacity:"0.8", margin:"0 0 0 3vw"}}>
    <div></div>
</div>
<p style={{fontWeight: 600}}>WET Squad <br/> <span>Today at 1:27 PM</span></p>
<svg xmlns="http://www.w3.org/2000/svg" width="6vw" height="6vw" viewBox="0 0 16 16" fill="#ffffff" className="bi bi-three-dots-vertical">
  <path d="M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z"/>
</svg>
</div>
<div className="pauseButtonContainer" ref={vidButton} style={{opacity:"0"}}>
<div className="pauseButtonVid">
<input type="checkbox" id="playpause" name="check" ref={vidPause} checked={isPlayingVid} readOnly/>
  <label htmlFor="playpause" tabIndex="0" aria-hidden="false">
    <svg viewBox="0 0 60 74" role="img" aria-hidden="true" focusable="false">
      <g className="icon-play" fill="#ffffff" stroke="#ffffff" strokeLinejoin="round" strokeLinecap="round" strokeWidth="6" vectorEffect="non-scaling-stroke">
        <polygon points="10,10 55,37 10,60" />
      </g>
      <g className="icon-pause" fill="#ffffff" transform="translate(0,0)">
        <rect x="10" y="10" width="12" height="50" rx="6" ry="6" />
        <rect x="36" y="10" width="12" height="50" rx="6" ry="6" />
      </g>
    </svg>
  </label>
</div>
</div>
<div className="bottomLineVid" ref={vidBottom} style={{transform:"translateY(8vh)"}}>
<progress className="progressVid" ref={vidProgress} value="0" max="100"></progress><p ref={vidTime}>00:00/25:23</p>
</div>
</div>
<div className='clickWrapVN' onClick={skipText} ref={wrap} id='wrap' style={{opacity:"1",zIndex:"10"}}><img src={loadingAnim} ref={loadingPic} style={{display:"none"}} /></div>
<div className='blackScreen' ref={fade} style={{opacity:"0", zIndex:"5", display:"none"}}></div>
<div className='blackScreen' ref={blackScreenRef} style={{display:"none", opacity:"0", zIndex:"8"}}></div>
<div className='backWrapVN' id="backWrapVNId" onClick={backMenuAppear} style={{zIndex:"11"}}>
<div className="arrowBackWrap" onClick={goToMenu} ref={arrowBack} style={{opacity:"0", display:"none", transform:"scale(1)"}}><div className="arrowBack" >
    <div></div>
</div>
</div>
</div>
<img src="" className='item' ref={item} style={{right:"100vw", top:"0vh", display:"none", transform: "scale(0)"}}/>
<img src="" className='char' ref={charRefLeft} style={{left:"-100vw", opacity:"0", bottom:"-20vh", transform:"translate(0px, 0px)", zIndex:4}}/>
<img src="" className='charUnder' ref={charRefLeftUnder} style={{left:"-100vw", bottom:"-20vh", zIndex:3}}/>
<img src="" className='char' ref={charRefRight} style={{right:"-100vw", opacity:"0", bottom:"-20vh", transform:"translate(0px, 0px)", zIndex:4}}/>
<img src="" className='charUnder' ref={charRefRightUnder} style={{right:"-100vw", bottom:"-20vh", zIndex:3}}/>
<img src={overlay} className='overlay' ref={particles} style={{opacity:"0.1"}}/>
<div className='sceneVN' ref={sceneRef} style={{display:"none", opacity:"1", filter:"saturate(1)"}}></div>
<div className='sceneVN' ref={sceneRefUnder} style={{display:"none", zIndex:"4"}}></div>
<div className='sceneVN' ref={sceneRefBG} style={{display:"none", zIndex:"4"}}></div>
<video className="sceneVNVid" ref={sceneRefVid} loop muted playsInline style={{left:"0vw", filter:"saturate(1)", transform:"translate(0vw, 0vh)", opacity:"1", zIndex:"6", display:"none"}}>
</video>
<video className="sceneVNVid" ref={sceneRefVidUnder} loop muted playsInline style={{left:"0vw", filter:"blur(0)", transform:"translate(0vw, 0vh)", opacity:"1", zIndex:"5", display:"none"}}>
</video>
<div className="viewport">
<img src={background} className='backgroundVN' ref={bgRef} style={{left:"0vw", filter:"blur(0)", transform:"translateX(0vw)", opacity:"1"}}/>
<img src="" className='backgroundVN' ref={bgRefUnder} style={{left:"0vw", filter:"blur(0)", transform:"translateX(0vw)", zIndex:"0", opacity:"1", display:"none"}}/>
<video className="backgroundVN" ref={bgRefVid} loop muted playsInline style={{left:"0vw", filter:"blur(0)", transform:"translateX(0vw)", opacity:"1", zIndex:"1", display:"none"}}>
</video>
<video className="backgroundVN" ref={bgRefVidUnder} loop muted playsInline style={{left:"0vw", filter:"blur(0)", transform:"translateX(0vw)", opacity:"1", zIndex:"0", display:"none"}}>
</video>
</div>
<div className="textBoxCover">
<div className="textBox" ref={textBoxLeft} style={{left:"0vw", opacity:"0",  top:"0vh", width:"100%", transform:"translate(-50vw, -20vh)"}}><h1>{charName}</h1><div id="textBoxLeft" ref={textBoxLeftInner} className="box-inner">{textBoxLeftText ? parse(textBoxLeftText) : parse(textBoxLeftText)}</div></div>
<div className="textBox" ref={textBoxRight} style={{right:"0vw", opacity:"0", top:"0vh", width:"100%", transform:"translate(50vw, -20vh)", borderRadius: "20px 2px 20px 2px"}}><h1>{charName}</h1><div id="textBoxRight" ref={textBoxRightInner} className="box-inner" style={{borderRadius: "13px 1px 13px 1px"}}>{textBoxRightText ? parse(textBoxRightText) : parse(textBoxRightText)}</div></div>
<div className='answersVN' ref={answersBox} style={{display:"none"}}>
    <div className='answerVN' ref={answerBox0} style={{opacity:"0", display:"none", transform: "scale(0)"}} onClick={answerHandler} name="0"></div>
    <div className='answerVN' ref={answerBox1} style={{opacity:"0", display:"none", transform: "scale(0)"}} onClick={answerHandler} name="1"></div>
    <div className='answerVN' ref={answerBox2} style={{opacity:"0", display:"none", transform: "scale(0)"}} onClick={answerHandler} name="2"></div>
    <div className='answerVN' ref={answerBox3} style={{opacity:"0", display:"none", transform: "scale(0)"}} onClick={answerHandler} name="3"></div>
</div>
<div className="status-bar" ref={timerText} style={{opacity:"0", display:"none"}}><div className="progress" id="progressText"></div></div>
</div>
<img src="" className='backgroundTapping' ref={bgTappingRef} style={{display: "none", left:"0vw", filter: "brightness(0.9)", transform:"translate(0vw, 0vh)"}}/>
</div>
  );
}

export default Vn;
